<template>
  <div>
    <!-- dashboard-grap -->
    <div class="call-setting">
      <div class="histoty-timeline text-right">
        <div class="timeline">
          <ul>
            <li>
              <a href="#" data-toggle="modal" data-target="#addcustomer"
                ><img
                  class="img-fluid"
                  src="../../assets/img/plus.svg"
                  alt=""
                />Customers</a
              >
            </li>
            <li>
              <a href="#" data-toggle="modal" data-target="#Appointment"
                ><img
                  class="img-fluid"
                  src="../../assets/img/plus.svg"
                  alt=""
                />
                Appointment</a
              >
            </li>
          </ul>
        </div>
      </div>
      <!-- call-box -->
      <div class="call-setting services-dash">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <a
              class="nav-link active"
              id="Flow-tab"
              data-toggle="tab"
              href="#Flow"
              role="tab"
              aria-controls="Flow"
              aria-selected="false"
              >Today’s Flow</a
            >
          </li>
          <li class="nav-item" role="presentation">
            <a
              class="nav-link"
              id="Book-tab"
              data-toggle="tab"
              href="#Book"
              role="tab"
              aria-controls="Book"
              aria-selected="false"
              >Work Book</a
            >
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="Flow"
            role="tabpanel"
            aria-labelledby="Flow-tab"
          >
            <div class="timeline">
              <button type="button" class="current">
                <span class="today">Today</span>
              </button>
              <button type="button">
                <span class="today">This month</span>
              </button>
              <button type="button">
                <input type="text" name="datefilter" value="" />
                <span class="month">Custom day</span>
              </button>
              <apexchart
                v-if="chart"
                type="bar"
                height="350"
                :options="chartOptions"
                :series="series"
              ></apexchart>
            </div>
        
            <div class="col-12">
              <!-- active-tabss -->
              <div class="active-tabss services-dash sale-active">
                <div class="tl">
                  <ul class="tl_btns">
                    <li class="active original-active">
                      <a href="#">
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                          >
                            <path
                              d="M28.0938 15.6016H21.7891V13.5C21.7891 13.1172 21.4766 12.7969 21.0859 12.7969C20.6953 12.7969 20.3828 13.1094 20.3828 13.5V16.3047C20.3828 16.6875 20.6953 17.0078 21.0859 17.0078H28.0938C28.4766 17.0078 28.7969 16.6953 28.7969 16.3047C28.7969 15.9141 28.4766 15.6016 28.0938 15.6016Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M32.9922 18.4062C30.6719 18.4062 28.7891 20.2891 28.7891 22.6094C28.7891 24.9297 30.6719 26.8125 32.9922 26.8125C35.3125 26.8125 37.1953 24.9297 37.1953 22.6094C37.1953 20.2891 35.3125 18.4062 32.9922 18.4062ZM32.9922 25.4062C31.4453 25.4062 30.1875 24.1484 30.1875 22.6016C30.1875 21.0547 31.4453 19.7969 32.9922 19.7969C34.5391 19.7969 35.7969 21.0547 35.7969 22.6016C35.7969 24.1484 34.5391 25.4062 32.9922 25.4062Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M11.9844 18.4062C9.66406 18.4062 7.78125 20.2891 7.78125 22.6094C7.78125 24.9297 9.66406 26.8125 11.9844 26.8125C14.3047 26.8125 16.1875 24.9297 16.1875 22.6094C16.1875 20.2891 14.2969 18.4062 11.9844 18.4062ZM11.9844 25.4062C10.4375 25.4062 9.17969 24.1484 9.17969 22.6016C9.17969 21.0547 10.4375 19.7969 11.9844 19.7969C13.5312 19.7969 14.7891 21.0547 14.7891 22.6016C14.7891 24.1484 13.5312 25.4062 11.9844 25.4062Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M29.4922 22.6094H15.4844C15.1016 22.6094 14.7812 22.9219 14.7812 23.3125C14.7812 23.6953 15.0938 24.0156 15.4844 24.0156H29.4922C29.875 24.0156 30.1953 23.7031 30.1953 23.3125C30.1953 22.9219 29.8828 22.6094 29.4922 22.6094Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M32.5469 14.2031C31.5234 13.3906 26.8438 10 19.6875 10C18.3359 10 14.8828 10.1406 11.7734 11.3984H8.48438C8.20313 11.3984 7.94531 11.5703 7.83594 11.8281C7.72656 12.0937 7.78906 12.3906 7.98438 12.5937L8.67188 13.2812C7.14844 14.6484 6.38281 16.3672 6.38281 18.4062C6.38281 20.8125 6.60156 24.0078 8.48438 24.0078C8.86719 24.0078 9.1875 23.6953 9.1875 23.3047C9.1875 22.9219 8.875 22.6016 8.48438 22.6016C8.47656 22.6016 7.78125 22.2109 7.78125 18.3984C7.78125 16.5391 8.54688 15.0625 10.1328 13.8906C10.2969 13.7656 10.3984 13.5859 10.4141 13.3828C10.4297 13.1797 10.3516 12.9844 10.2109 12.8359L10.1719 12.7969H11.9062C12 12.7969 12.0938 12.7813 12.1719 12.7422C15.0859 11.5313 18.3906 11.3984 19.6797 11.3984C27.0938 11.3984 31.7812 15.3906 31.8281 15.4297C31.9531 15.5391 32.1172 15.6016 32.2891 15.6016C36.8281 15.6016 38.5859 18.5078 38.5938 19.1016V21.9062C38.5938 22.2734 38.0547 22.5859 37.8906 22.6094H36.4922C36.1094 22.6094 35.7891 22.9219 35.7891 23.3125C35.7891 23.6953 36.1016 24.0156 36.4922 24.0156H37.8906C38.7344 24.0156 39.9922 23.1328 39.9922 21.9141V19.1094C40 17.7813 37.7031 14.3125 32.5469 14.2031Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M5.23023 24.7656H1.55233C1.24693 24.7656 1 24.4688 1 24.1016C1 23.7344 1.24693 23.4375 1.55233 23.4375H5.23673C5.54214 23.4375 5.78906 23.7344 5.78906 24.1016C5.78906 24.4688 5.53564 24.7656 5.23023 24.7656Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M3.33594 21.3281H0.882812C0.515625 21.3281 0.21875 21.0312 0.21875 20.6641C0.21875 20.2969 0.515625 20 0.882812 20H3.32812C3.69531 20 3.99219 20.2969 3.99219 20.6641C3.99219 21.0312 3.70312 21.3281 3.33594 21.3281Z"
                              fill="#A2A8B8"
                            />
                          </svg>
                        </span>
                        <p>Pending Arrival</p>
                        <h5>10</h5>
                        <img
                          class="img-fluid"
                          src="../../assets/img/shadow.svg"
                          alt=""
                        />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                          >
                            <path
                              d="M38.3812 9.43124L20.2563 1.30624C20.1759 1.26919 20.0885 1.25 20 1.25C19.9115 1.25 19.8241 1.26919 19.7437 1.30624L1.61875 9.43124C1.50909 9.48054 1.41598 9.56041 1.35058 9.66129C1.28517 9.76217 1.25025 9.87977 1.25 9.99999V38.125C1.25 38.2908 1.31585 38.4497 1.43306 38.5669C1.55027 38.6841 1.70924 38.75 1.875 38.75H4.375C4.54076 38.75 4.69973 38.6841 4.81694 38.5669C4.93415 38.4497 5 38.2908 5 38.125V20H35V38.125C35 38.2908 35.0658 38.4497 35.1831 38.5669C35.3003 38.6841 35.4592 38.75 35.625 38.75H38.125C38.2908 38.75 38.4497 38.6841 38.5669 38.5669C38.6842 38.4497 38.75 38.2908 38.75 38.125V9.99999C38.7497 9.87977 38.7148 9.76217 38.6494 9.66129C38.584 9.56041 38.4909 9.48054 38.3812 9.43124ZM3.75 37.5H2.5V12.5H3.75V37.5ZM35 18.75H5V17.5H35V18.75ZM35 16.25H5V15H35V16.25ZM35 13.75H5V12.5H35V13.75ZM37.5 37.5H36.25V12.5H37.5V37.5ZM37.5 11.25H2.5V10.4062L20 2.56249L37.5 10.4062V11.25Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M25 30.625H15C14.905 30.625 14.8112 30.6467 14.7259 30.6883C14.6405 30.73 14.5657 30.7906 14.5073 30.8655C14.4488 30.9404 14.4082 31.0276 14.3885 31.1206C14.3689 31.2135 14.3706 31.3097 14.3937 31.4019L14.6637 32.4812C14.7982 33.0225 15.1101 33.503 15.5497 33.8463C15.9892 34.1895 16.531 34.3757 17.0887 34.375H22.9112C23.4689 34.3757 24.0108 34.1895 24.4503 33.8463C24.8898 33.503 25.2017 33.0225 25.3362 32.4812L25.6062 31.4019C25.6293 31.3097 25.6311 31.2135 25.6114 31.1206C25.5917 31.0276 25.5511 30.9404 25.4927 30.8655C25.4342 30.7906 25.3595 30.73 25.2741 30.6883C25.1887 30.6467 25.095 30.625 25 30.625ZM24.125 32.1781C24.0573 32.4488 23.9011 32.689 23.6812 32.8606C23.4612 33.0322 23.1902 33.1252 22.9112 33.125H17.0887C16.81 33.125 16.5393 33.0317 16.3196 32.8602C16.0999 32.6886 15.9438 32.4485 15.8762 32.1781L15.8006 31.875H24.1994L24.125 32.1781Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M33.125 25.9375C33.125 25.5231 32.9604 25.1257 32.6674 24.8326C32.3743 24.5396 31.9769 24.375 31.5625 24.375H30.6688C30.3594 24.3745 30.0547 24.4507 29.782 24.5969C29.5093 24.7431 29.2771 24.9546 29.1063 25.2125L29.0125 25.35L28.8188 24.5625C28.5819 23.6163 28.0356 22.7764 27.2667 22.1762C26.4978 21.5761 25.5504 21.2501 24.575 21.25H15.425C14.4496 21.2501 13.5022 21.5761 12.7333 22.1762C11.9644 22.7764 11.4181 23.6163 11.1812 24.5625L10.9875 25.35L10.8938 25.2125C10.7229 24.9546 10.4907 24.7431 10.218 24.5969C9.94532 24.4507 9.64064 24.3745 9.33125 24.375H8.4375C8.0231 24.375 7.62567 24.5396 7.33265 24.8326C7.03962 25.1257 6.875 25.5231 6.875 25.9375C6.875 26.3519 7.03962 26.7493 7.33265 27.0424C7.62567 27.3354 8.0231 27.5 8.4375 27.5H8.76875C8.35323 28.0369 8.1269 28.6961 8.125 29.375V34.375C8.12699 34.7616 8.24806 35.1382 8.47172 35.4536C8.69538 35.769 9.01079 36.0078 9.375 36.1375V36.875C9.37648 37.3718 9.5745 37.8479 9.92581 38.1992C10.2771 38.5505 10.7532 38.7485 11.25 38.75H13.75C14.2468 38.7485 14.7229 38.5505 15.0742 38.1992C15.4255 37.8479 15.6235 37.3718 15.625 36.875V36.25H24.375V36.875C24.3765 37.3718 24.5745 37.8479 24.9258 38.1992C25.2771 38.5505 25.7532 38.7485 26.25 38.75H28.75C29.2468 38.7485 29.7229 38.5505 30.0742 38.1992C30.4255 37.8479 30.6235 37.3718 30.625 36.875V36.1375C30.9892 36.0078 31.3046 35.769 31.5283 35.4536C31.7519 35.1382 31.873 34.7616 31.875 34.375V29.375C31.8731 28.6961 31.6468 28.0369 31.2313 27.5H31.5625C31.9769 27.5 32.3743 27.3354 32.6674 27.0424C32.9604 26.7493 33.125 26.3519 33.125 25.9375ZM12.3938 24.8688C12.5624 24.1924 12.9524 23.5919 13.5017 23.1627C14.0509 22.7334 14.7279 22.5002 15.425 22.5H24.575C25.2721 22.5002 25.9491 22.7334 26.4983 23.1627C27.0476 23.5919 27.4376 24.1924 27.6062 24.8688L28.0562 26.6687C27.482 27.2021 26.7275 27.499 25.9437 27.5H14.0562C13.2725 27.499 12.518 27.2021 11.9438 26.6687L12.3938 24.8688ZM8.4375 26.25C8.35462 26.25 8.27513 26.2171 8.21653 26.1585C8.15792 26.0999 8.125 26.0204 8.125 25.9375C8.125 25.8546 8.15792 25.7751 8.21653 25.7165C8.27513 25.6579 8.35462 25.625 8.4375 25.625H9.33125C9.43419 25.6255 9.53541 25.6515 9.62591 25.7006C9.71641 25.7496 9.79338 25.8203 9.85 25.9063L10.0812 26.25H8.4375ZM9.375 30.8688L11.875 31.7V31.875C11.875 32.0408 11.8092 32.1997 11.6919 32.3169C11.5747 32.4342 11.4158 32.5 11.25 32.5H9.375V30.8688ZM14.375 36.875C14.375 37.0408 14.3092 37.1997 14.1919 37.3169C14.0747 37.4342 13.9158 37.5 13.75 37.5H11.25C11.0842 37.5 10.9253 37.4342 10.8081 37.3169C10.6908 37.1997 10.625 37.0408 10.625 36.875V36.25H14.375V36.875ZM29.375 36.875C29.375 37.0408 29.3092 37.1997 29.1919 37.3169C29.0747 37.4342 28.9158 37.5 28.75 37.5H26.25C26.0842 37.5 25.9253 37.4342 25.8081 37.3169C25.6908 37.1997 25.625 37.0408 25.625 36.875V36.25H29.375V36.875ZM30.625 32.5H28.75C28.5842 32.5 28.4253 32.4342 28.3081 32.3169C28.1908 32.1997 28.125 32.0408 28.125 31.875V31.7L30.625 30.8688V32.5ZM30.625 29.55L27.3 30.6562C27.1766 30.6993 27.0695 30.7795 26.9934 30.8858C26.9173 30.9921 26.876 31.1193 26.875 31.25V31.875C26.8765 32.3718 27.0745 32.8479 27.4258 33.1992C27.7771 33.5505 28.2532 33.7485 28.75 33.75H30.625V34.375C30.625 34.5408 30.5592 34.6997 30.4419 34.8169C30.3247 34.9342 30.1658 35 30 35H10C9.83424 35 9.67527 34.9342 9.55806 34.8169C9.44085 34.6997 9.375 34.5408 9.375 34.375V33.75H11.25C11.7468 33.7485 12.2229 33.5505 12.5742 33.1992C12.9255 32.8479 13.1235 32.3718 13.125 31.875V31.25C13.124 31.1193 13.0827 30.9921 13.0066 30.8858C12.9305 30.7795 12.8234 30.6993 12.7 30.6562L9.375 29.55V29.375C9.37558 28.919 9.54313 28.4791 9.84598 28.1382C10.1488 27.7974 10.566 27.5792 11.0187 27.525C11.8334 28.3128 12.923 28.7523 14.0562 28.75H25.9437C27.077 28.7523 28.1666 28.3128 28.9812 27.525C29.434 27.5792 29.8512 27.7974 30.154 28.1382C30.4569 28.4791 30.6244 28.919 30.625 29.375V29.55ZM29.9187 26.25L30.15 25.9063C30.2066 25.8203 30.2836 25.7496 30.3741 25.7006C30.4646 25.6515 30.5658 25.6255 30.6688 25.625H31.5625C31.6454 25.625 31.7249 25.6579 31.7835 25.7165C31.8421 25.7751 31.875 25.8546 31.875 25.9375C31.875 26.0204 31.8421 26.0999 31.7835 26.1585C31.7249 26.2171 31.6454 26.25 31.5625 26.25H29.9187Z"
                              fill="#A2A8B8"
                            />
                          </svg>
                        </span>
                        <p>At Dealer</p>
                        <h5>15</h5>
                        <img
                          class="img-fluid"
                          src="../../assets/img/shadow.svg"
                          alt=""
                        />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                          >
                            <path
                              d="M20.0003 20.7715C22.3705 20.7715 24.6851 19.3333 26.5176 16.7219C28.1348 14.4173 29.1002 11.568 29.1002 9.0999C29.1003 4.08223 25.018 0 20.0003 0C14.9826 0 10.9004 4.08223 10.9004 9.0999C10.9004 11.568 11.8658 14.4173 13.483 16.7219C15.3155 19.3333 17.6301 20.7715 20.0003 20.7715ZM20.0003 1.48387C24.1998 1.48387 27.6163 4.90044 27.6163 9.0999C27.6163 11.2421 26.7299 13.836 25.303 15.8695C23.7786 18.0417 21.8459 19.2876 20.0003 19.2876C18.1547 19.2876 16.222 18.0417 14.6976 15.8695C13.2707 13.836 12.3843 11.2421 12.3843 9.0999C12.3843 4.90044 15.8008 1.48387 20.0003 1.48387Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M33.335 24.841C31.7316 22.3526 29.4744 20.3663 26.8072 19.0966C26.5239 18.9618 26.1866 19.0196 25.9644 19.2411C24.1767 21.0239 22.1142 21.966 19.9999 21.966C17.8853 21.966 15.8231 21.0239 14.0365 19.2412C13.8143 19.0195 13.4768 18.9616 13.1936 19.0965C10.5263 20.3662 8.26887 22.3526 6.6653 24.8409C5.0181 27.3968 4.14746 30.3622 4.14746 33.4163V33.4292C4.14746 33.6385 4.2359 33.8381 4.39092 33.9788C8.67199 37.8613 14.2153 39.9995 19.9998 39.9995C25.7842 39.9995 31.3275 37.8613 35.6087 33.9788C35.7637 33.8381 35.8521 33.6386 35.8521 33.4292V33.4163C35.8523 30.3622 34.9819 27.3968 33.335 24.841ZM19.9999 38.5157C14.6954 38.5157 9.60733 36.5949 5.6348 33.1002C5.69247 30.4436 6.47704 27.8723 7.91264 25.6447C9.27454 23.5316 11.1562 21.8177 13.376 20.6632C15.3589 22.4886 17.639 23.4499 19.9999 23.4499C22.3603 23.4499 24.6409 22.4884 26.6248 20.6631C28.8444 21.8175 30.726 23.5315 32.0876 25.6446C33.5229 27.8721 34.3073 30.4433 34.365 33.1001C30.3924 36.5948 25.3043 38.5157 19.9999 38.5157Z"
                              fill="#A2A8B8"
                            />
                          </svg>
                        </span>
                        <p>With Advisor</p>
                        <h5>2</h5>
                        <img
                          class="img-fluid"
                          src="../../assets/img/shadow.svg"
                          alt=""
                        />
                      </a>
                    </li>
                    <li>
                      <a href="#"
                        ><span
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                          >
                            <path
                              d="M20.0003 20.7715C22.3705 20.7715 24.6851 19.3333 26.5176 16.7219C28.1348 14.4173 29.1002 11.568 29.1002 9.0999C29.1003 4.08223 25.018 0 20.0003 0C14.9826 0 10.9004 4.08223 10.9004 9.0999C10.9004 11.568 11.8658 14.4173 13.483 16.7219C15.3155 19.3333 17.6301 20.7715 20.0003 20.7715ZM20.0003 1.48387C24.1998 1.48387 27.6163 4.90044 27.6163 9.0999C27.6163 11.2421 26.7299 13.836 25.303 15.8695C23.7786 18.0417 21.8459 19.2876 20.0003 19.2876C18.1547 19.2876 16.222 18.0417 14.6976 15.8695C13.2707 13.836 12.3843 11.2421 12.3843 9.0999C12.3843 4.90044 15.8008 1.48387 20.0003 1.48387Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M33.335 24.841C31.7316 22.3526 29.4744 20.3663 26.8072 19.0966C26.5239 18.9618 26.1866 19.0196 25.9644 19.2411C24.1767 21.0239 22.1142 21.966 19.9999 21.966C17.8853 21.966 15.8231 21.0239 14.0365 19.2412C13.8143 19.0195 13.4768 18.9616 13.1936 19.0965C10.5263 20.3662 8.26887 22.3526 6.6653 24.8409C5.0181 27.3968 4.14746 30.3622 4.14746 33.4163V33.4292C4.14746 33.6385 4.2359 33.8381 4.39092 33.9788C8.67199 37.8613 14.2153 39.9995 19.9998 39.9995C25.7842 39.9995 31.3275 37.8613 35.6087 33.9788C35.7637 33.8381 35.8521 33.6386 35.8521 33.4292V33.4163C35.8523 30.3622 34.9819 27.3968 33.335 24.841ZM19.9999 38.5157C14.6954 38.5157 9.60733 36.5949 5.6348 33.1002C5.69247 30.4436 6.47704 27.8723 7.91264 25.6447C9.27454 23.5316 11.1562 21.8177 13.376 20.6632C15.3589 22.4886 17.639 23.4499 19.9999 23.4499C22.3603 23.4499 24.6409 22.4884 26.6248 20.6631C28.8444 21.8175 30.726 23.5315 32.0876 25.6446C33.5229 27.8721 34.3073 30.4433 34.365 33.1001C30.3924 36.5948 25.3043 38.5157 19.9999 38.5157Z"
                              fill="#A2A8B8"
                            /></svg
                        ></span>
                        <p>With Advisor</p>
                        <h5>2</h5>
                        <img
                          class="img-fluid"
                          src="assets/img/shadow.svg"
                          alt=""
                      /></a>
                    </li>

                    <li class="vvv">
                      <a href="#"
                        ><span
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            version="1.1"
                            id="Layer_1"
                            x="0px"
                            y="0px"
                            viewBox="0 0 40 40"
                            style="enable-background: new 0 0 40 40"
                            xml:space="preserve"
                          >
                            <g>
                              <path
                                class="st0"
                                d="M39.5,18.8L27.1,6.4c-0.3-0.3-0.8-0.3-1.2,0c-0.3,0.3-0.3,0.8,0,1.2l11,11H0.8c-0.5,0-0.8,0.4-0.8,0.8   s0.4,0.8,0.8,0.8h36.1l-11,11c-0.3,0.3-0.3,0.8,0,1.2c0.2,0.2,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2L39.5,20   C39.8,19.6,39.8,19.1,39.5,18.8z"
                              />
                              <rect class="st1" width="40" height="40" />
                            </g></svg
                        ></span>
                        <p>Checked In</p>
                        <h5>2</h5>
                        <img
                          class="img-fluid"
                          src="assets/img/shadow.svg"
                          alt=""
                      /></a>
                    </li>
                    <li>
                      <a href="#">
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                          >
                            <path
                              d="M37.9559 9.46898L31.7595 8.27148L29.1794 1.50203C28.8369 0.603594 27.9609 0 26.9996 0H24.1474C23.3727 0.0239844 23.3733 1.14813 24.1474 1.17188H26.9996C27.478 1.17188 27.9139 1.47227 28.0843 1.91938L30.7806 8.99359C30.8528 9.18305 31.0179 9.32172 31.217 9.36016L37.7336 10.6195C38.3678 10.7421 38.8281 11.3 38.8281 11.946V12.1803H37.2316C36.457 12.2043 36.4575 13.3284 37.2316 13.3522H38.8281V18.71H34.7342C33.9986 14.6127 28.2059 14.6155 27.4719 18.71H12.5281C11.7925 14.6127 5.99977 14.6155 5.26578 18.71H1.17188V13.3522H2.76836C3.54305 13.3282 3.5425 12.2041 2.76836 12.1803H1.17188V11.946C1.17188 11.2999 1.63219 10.742 2.26641 10.6195L8.78305 9.36016C8.98211 9.32164 9.14719 9.18297 9.21938 8.99359L11.9157 1.91938C12.0861 1.47227 12.522 1.17188 13.0004 1.17188H21.4776C22.2523 1.14789 22.2517 0.02375 21.4776 0H13.0004C12.0391 0 11.163 0.603594 10.8206 1.50203L8.24047 8.27148L2.04398 9.46898C0.859609 9.69789 0 10.7396 0 11.9461V19.296C0 19.6196 0.262344 19.882 0.585938 19.882H5.26578C6.00141 23.9793 11.7941 23.9764 12.5281 19.882H14.1541V22.7437C14.1541 23.0673 14.4165 23.3296 14.7401 23.3296H16.2891V33.1992H9.00648C7.05578 33.1991 5.46875 34.7862 5.46875 36.7371V38.8281H3.71094C2.93625 38.8521 2.9368 39.9762 3.71094 40H8.64133C9.41602 39.976 9.41547 38.8519 8.64133 38.8281H6.64062V36.7371C6.64062 35.4324 7.70195 34.3709 9.00648 34.3709H30.9936C32.2981 34.3709 33.3595 35.4323 33.3595 36.7371V38.8281H11.3553C10.5806 38.8521 10.5812 39.9762 11.3553 40H36.2891C37.0638 39.976 37.0632 38.8519 36.2891 38.8281H34.5312V36.7371C34.5312 34.7862 32.9442 33.1991 30.9935 33.1991H23.7109V30.8895C23.687 30.1148 22.5628 30.1153 22.5391 30.8895V33.1991H17.4609V23.3295H22.5391V28.2027C22.563 28.9773 23.6872 28.9768 23.7109 28.2027V23.3295H25.2598C25.5834 23.3295 25.8458 23.0672 25.8458 22.7436V19.8819H27.4718C28.2074 23.9792 34.0002 23.9763 34.7341 19.8819H39.4141C39.7377 19.8819 40 19.6195 40 19.2959V11.9461C40 10.7396 39.1404 9.69789 37.9559 9.46898ZM8.89695 21.8023C7.51508 21.8023 6.39094 20.6779 6.39094 19.2959C6.51695 15.9755 11.2774 15.9764 11.403 19.2959C11.403 20.678 10.2787 21.8023 8.89695 21.8023ZM24.6739 22.1577H15.3261V19.8819H24.6739V22.1577ZM31.103 21.8023C29.7212 21.8023 28.597 20.6779 28.597 19.2959C28.723 15.9755 33.4836 15.9764 33.6091 19.2959C33.6091 20.678 32.4848 21.8023 31.103 21.8023Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M29.2719 9.18445C29.3812 9.02547 29.4053 8.82289 29.3363 8.64273L27.0706 2.73172C26.9837 2.50508 26.7662 2.35547 26.5235 2.35547H18.8281C18.5045 2.35547 18.2422 2.61781 18.2422 2.94141V8.85242C18.2422 9.17602 18.5045 9.43836 18.8281 9.43836H28.7891C28.982 9.43844 29.1626 9.34344 29.2719 9.18445ZM19.4141 8.26656V3.52742H26.1205L27.937 8.26656H19.4141Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M13.4766 2.35547C13.2339 2.35547 13.0162 2.50508 12.9294 2.73172L10.6638 8.64273C10.5948 8.82289 10.6188 9.02547 10.7282 9.18445C10.8375 9.34344 11.018 9.43836 11.211 9.43836H16.4844C16.808 9.43836 17.0703 9.17602 17.0703 8.85242V2.94141C17.0703 2.61781 16.808 2.35547 16.4844 2.35547H13.4766ZM15.8984 8.26648H12.063L13.8794 3.52734H15.8984V8.26648Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M18.8279 10.5967C18.0532 10.6207 18.0537 11.7448 18.8279 11.7686H20.9882C21.7629 11.7446 21.7623 10.6204 20.9882 10.5967H18.8279Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M31.1023 18.71C30.3278 18.7339 30.328 19.858 31.1023 19.8818C31.8768 19.8579 31.8767 18.7338 31.1023 18.71Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M8.89722 18.71C8.12269 18.7339 8.12292 19.858 8.89722 19.8818C9.67175 19.8579 9.67159 18.7338 8.89722 18.71Z"
                              fill="#A2A8B8"
                            />
                          </svg>
                        </span>
                        <p>In Progress</p>
                        <h5>5</h5>
                        <img
                          class="img-fluid"
                          src="../../assets/img/shadow.svg"
                          alt=""
                        />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                          >
                            <path
                              d="M38.3783 35.6762H12.4324C12.289 35.6762 12.1516 35.6193 12.0502 35.5179C11.9488 35.4165 11.8919 35.279 11.8919 35.1357C11.8919 32.2708 9.7297 30.5681 7.21078 28.5951C4.3243 26.3411 1.08105 23.7843 1.08105 18.9194C1.08105 18.7761 1.138 18.6386 1.23938 18.5372C1.34075 18.4359 1.47823 18.3789 1.6216 18.3789H38.3783C38.5217 18.3789 38.6592 18.4359 38.7606 18.5372C38.8619 18.6386 38.9189 18.7761 38.9189 18.9194V35.1357C38.9189 35.279 38.8619 35.4165 38.7606 35.5179C38.6592 35.6193 38.5217 35.6762 38.3783 35.6762ZM12.9729 34.5951H37.8378V19.46H2.16214C2.39457 23.4492 5.17295 25.633 7.86484 27.7465C10.3567 29.687 12.7027 31.5303 12.9729 34.5951Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M38.3783 19.4599H1.62158C1.50718 19.4603 1.39561 19.4244 1.30291 19.3574C1.21021 19.2903 1.14117 19.1956 1.10572 19.0869C1.07026 18.9781 1.07023 18.8609 1.10562 18.7521C1.14101 18.6433 1.21 18.5486 1.30266 18.4815C5.32428 15.5788 7.2486 12.6328 8.7459 10.2653C10.9081 6.94636 12.5729 4.31934 18.5297 4.31934H38.3783C38.5217 4.31934 38.6592 4.37629 38.7606 4.47766C38.8619 4.57903 38.9189 4.71652 38.9189 4.85988V18.9193C38.9189 19.0627 38.8619 19.2002 38.7606 19.3016C38.6592 19.4029 38.5217 19.4599 38.3783 19.4599ZM3.2432 18.3788H37.8378V5.40582H18.5297C13.1621 5.40582 11.7675 7.56798 9.65941 10.8491C7.96948 13.7092 5.79893 16.2564 3.2432 18.3788Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M36.2157 17.2971H7.30215C7.19665 17.2975 7.09335 17.267 7.00498 17.2094C6.91662 17.1517 6.84705 17.0695 6.80485 16.9728C6.76369 16.8773 6.75097 16.7719 6.76823 16.6693C6.78549 16.5667 6.83199 16.4713 6.90215 16.3944C8.26353 14.8502 9.48967 13.1919 10.567 11.4377C12.6859 8.14038 13.7562 6.48633 18.5292 6.48633H36.2157C36.359 6.48633 36.4965 6.54328 36.5979 6.64465C36.6992 6.74602 36.7562 6.88351 36.7562 7.02687V16.7566C36.7562 16.9 36.6992 17.0374 36.5979 17.1388C36.4965 17.2402 36.359 17.2971 36.2157 17.2971ZM8.48593 16.2161H35.6751V7.56741H18.5292C14.3454 7.56741 13.5616 8.77822 11.5021 12.0215C10.5882 13.4832 9.58067 14.8843 8.48593 16.2161Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M15.6758 7.20996H16.7569V16.7559H15.6758V7.20996Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M36.2156 23.7833H25.4048C25.2614 23.7833 25.1239 23.7263 25.0226 23.625C24.9212 23.5236 24.8643 23.3861 24.8643 23.2427V21.0806C24.8643 20.9372 24.9212 20.7997 25.0226 20.6984C25.1239 20.597 25.2614 20.54 25.4048 20.54H36.2156C36.359 20.54 36.4965 20.597 36.5978 20.6984C36.6992 20.7997 36.7561 20.9372 36.7561 21.0806V23.2427C36.7561 23.3861 36.6992 23.5236 36.5978 23.625C36.4965 23.7263 36.359 23.7833 36.2156 23.7833ZM25.9453 22.7022H35.6751V21.6211H25.9453V22.7022Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M28.1074 21.0811H29.1885V23.2432H28.1074V21.0811Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M23.2432 30.2705H38.3783V31.3516H23.2432V30.2705Z"
                              fill="#A2A8B8"
                            />
                            <path
                              d="M2.44336 22.1621H17.2974V23.2432H2.44336V22.1621Z"
                              fill="#A2A8B8"
                            />
                          </svg>
                        </span>
                        <p>Parts Pending</p>
                        <h5>3</h5>
                        <img
                          class="img-fluid"
                          src="../../assets/img/shadow.svg"
                          alt=""
                        />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                          >
                            <path
                              d="M32.9561 22.4232C31.5692 22.2909 28.9674 22.831 26.6763 24.1185C26.0532 24.4684 25.3114 24.4608 24.6923 24.0984C24.0667 23.7322 23.6933 23.0815 23.6933 22.3578V5.25957C23.6933 4.43175 23.3709 3.65342 22.785 3.06767C22.1817 2.46563 21.3783 2.14415 20.5278 2.1617C19.827 2.17635 19.1816 2.43361 18.6675 2.85198C18.5411 1.25838 17.2048 0 15.5793 0C13.8706 0 12.4805 1.3901 12.4805 3.09878V3.25015C11.9527 2.83351 11.2874 2.58398 10.5643 2.58398C8.85566 2.58398 7.46556 3.97408 7.46556 5.68276V11.0841C7.02817 10.7711 6.4991 10.5831 5.92945 10.5743C5.17395 10.5633 4.46639 10.8495 3.93195 11.3828C3.41033 11.9044 3.12305 12.5982 3.12305 13.3364V30.7976C3.12305 32.2496 3.32964 33.6926 3.73691 35.0863C4.1127 36.3722 4.30328 37.7036 4.30328 39.0433V39.4087C4.30328 39.7353 4.568 40 4.89458 40H21.6186C21.9452 40 22.2099 39.7353 22.2099 39.4087V36.8363C22.2099 36.5409 22.2935 36.2534 22.4525 36.0038C22.6104 35.7546 22.8354 35.5562 23.1025 35.4303C24.0737 34.9739 24.9811 34.3851 25.7994 33.6804C28.3913 31.4512 31.4035 29.0586 34.3522 28.8869C35.7366 28.8072 36.8201 27.7085 36.8729 26.3272L36.8745 26.2773C36.952 24.2351 35.3406 22.6503 32.9561 22.4232ZM35.6925 26.2362L35.6909 26.2859C35.6617 27.0511 35.0569 27.6616 34.2837 27.7061C30.9663 27.8993 27.7668 30.4283 25.028 32.7839C24.2907 33.4188 23.4735 33.9491 22.5989 34.3602C22.1279 34.5821 21.7319 34.9315 21.4542 35.3696C21.175 35.8082 21.0273 36.3153 21.0273 36.8361V38.8172H5.48424C5.46387 37.4416 5.25819 36.0759 4.87202 34.7544C4.49623 33.4686 4.30565 32.1373 4.30565 30.7975V13.3363C4.30565 12.914 4.46994 12.5172 4.76777 12.2194C5.07361 11.9142 5.48252 11.749 5.91098 11.7566C6.76809 11.77 7.46537 12.5004 7.46537 13.385L7.46556 20.6314C7.46556 20.958 7.73028 21.2227 8.05686 21.2227C8.38343 21.2227 8.64816 20.958 8.64816 20.6314V5.68267C8.64816 4.62606 9.50772 3.76649 10.5643 3.76649C11.6209 3.76649 12.4805 4.62606 12.4805 5.68267V18.2727V19.3287C12.4805 19.6553 12.7452 19.92 13.0718 19.92C13.3984 19.92 13.6631 19.6553 13.6631 19.3287V18.2727V3.09878C13.6631 2.04217 14.5227 1.1826 15.5793 1.1826C16.6359 1.1826 17.4955 2.04217 17.4955 3.09878L17.4953 18.2726C17.4953 18.4972 17.6205 18.6925 17.8049 18.7926C17.8887 18.8381 17.9848 18.864 18.0869 18.864C18.4134 18.864 18.6782 18.5993 18.6782 18.2727V5.30542C18.6805 4.24508 19.5203 3.36559 20.5525 3.34394C21.0817 3.33348 21.5763 3.53206 21.9492 3.90422C22.3112 4.26628 22.5107 4.74759 22.5107 5.25948V22.3578C22.5107 23.5061 23.1029 24.5383 24.0949 25.119C25.0804 25.6959 26.2619 25.7074 27.2555 25.1495C29.5628 23.853 31.9073 23.511 32.844 23.6004C34.8735 23.7938 35.7371 25.0616 35.6925 26.2362Z"
                              fill="#A2A8B8"
                            />
                          </svg>
                        </span>
                        <p>Hold For Approval</p>
                        <h5>5</h5>
                        <img
                          class="img-fluid"
                          src="../../assets/img/shadow.svg"
                          alt=""
                        />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="41"
                            height="29"
                            viewBox="0 0 41 29"
                            fill="none"
                          >
                            <path
                              d="M2.40352 15.2636C2.11016 14.9712 1.63529 14.9719 1.34286 15.2653C1.05043 15.5586 1.05118 16.0335 1.34453 16.3259L2.40352 15.2636ZM13.3029 27.1876L12.7734 27.7188C13.0661 28.0106 13.5397 28.0106 13.8324 27.7188L13.3029 27.1876ZM39.5473 2.08488C39.8406 1.79245 39.8414 1.31757 39.5489 1.02422C39.2565 0.730863 38.7816 0.730114 38.4883 1.02255L39.5473 2.08488ZM1.34453 16.3259L12.7734 27.7188L13.8324 26.6565L2.40352 15.2636L1.34453 16.3259ZM13.8324 27.7188L39.5473 2.08488L38.4883 1.02255L12.7734 26.6565L13.8324 27.7188Z"
                              fill="#A2A8B8"
                            />
                          </svg>
                        </span>
                        <p>Completed</p>
                        <h5>2</h5>
                        <img
                          class="img-fluid"
                          src="../../assets/img/shadow.svg"
                          alt=""
                        />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- active -tabss -->
            </div>
            <!-- customer -->
            <div class="cusomer-services">
              <div class="row">
                <div class="col-12">
                  <div class="cus-title">
                    <h3>Customers</h3>
                  </div>
                </div>
                <div class="col-md-8 col-lg-9">
                  <!-- customers -->
                  <div class="customers">
                    <div class="row">
                      <div class="col-md-6 col-lg-4">
                        <div class="customttile">
                          <h4>Arrived</h4>
                        </div>
                        <div class="customer-box">
                          <ul class="sortable connectedSortable">
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >01. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >02. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >03. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >04. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >05. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >06. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >07. Jonathaon Paul
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4">
                        <div class="customttile">
                          <h4>Late</h4>
                        </div>
                        <div class="customer-box">
                          <ul class="sortable connectedSortable">
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >01. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >02. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >03. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >04. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >05. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >06. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >07. Jonathaon Paul
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4">
                        <div class="customttile">
                          <h4>No Show</h4>
                        </div>
                        <div class="customer-box">
                          <ul class="sortable connectedSortable">
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >01. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >02. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >03. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >04. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >05. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >06. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >07. Jonathaon Paul
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4">
                        <div class="customttile">
                          <h4>Pending Arrival</h4>
                        </div>
                        <div class="customer-box">
                          <ul class="sortable connectedSortable">
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >01. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >02. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >03. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >04. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >05. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >06. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >07. Jonathaon Paul
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4">
                        <div class="customttile">
                          <h4>Pending Parts</h4>
                        </div>
                        <div class="customer-box">
                          <ul class="sortable connectedSortable">
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >01. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >02. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >03. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >04. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >05. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >06. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >07. Jonathaon Paul
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-4">
                        <div class="customttile">
                          <h4>Complete</h4>
                        </div>
                        <div class="customer-box">
                          <ul class="sortable connectedSortable">
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >01. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >02. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >03. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >04. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >05. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >06. Jonathaon Paul
                            </li>
                            <li class="ui-state-default">
                              <span class="ddd"
                                ><img
                                  class="img-fluid"
                                  src="assets/img/dots.svg"
                                  alt="" /></span
                              >07. Jonathaon Paul
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- customers -->
                </div>
                <!-- right -->
                <div class="col-md-4 col-lg-3">
                  <div class="customer-appo">
                    <h4>Total Appointments</h4>
                    <table class="table">
                      <tbody>
                        <tr>
                          <td>DMS</td>
                          <td>05</td>
                        </tr>
                        <tr>
                          <td>DealerGear</td>
                          <td>03</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="customer-appo">
                    <h4>Total Check Ins</h4>
                    <table class="table">
                      <tbody>
                        <tr>
                          <td>DMS</td>
                          <td>05</td>
                        </tr>
                        <tr>
                          <td>DealerGear</td>
                          <td>03</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- right -->
              </div>
            </div>
            <!-- customer -->
          </div>
          <!-- Today’s Flow-end -->
          <!-- Book-tab-start -->
          <div
            class="tab-pane fade"
            id="Book"
            role="tabpanel"
            aria-labelledby="Book-tab"
          >
            <div class="book-tabs">
              <!-- time-tabs -->
              <div class="time-tabs">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                    <a
                      class="nav-link active"
                      id="Today-tab"
                      data-toggle="tab"
                      href="#Today"
                      role="tab"
                      aria-controls="Today"
                      aria-selected="true"
                      >Today</a
                    >
                  </li>
                  <li class="nav-item" role="presentation">
                    <a
                      class="nav-link"
                      id="Week-tab"
                      data-toggle="tab"
                      href="#Week"
                      role="tab"
                      aria-controls="Week"
                      aria-selected="false"
                      >Week</a
                    >
                  </li>
                  <li class="nav-item" role="presentation">
                    <a
                      class="nav-link"
                      id="Month-tab"
                      data-toggle="tab"
                      href="#Month"
                      role="tab"
                      aria-controls="Month"
                      aria-selected="false"
                      >Month</a
                    >
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div
                    class="tab-pane fade show active"
                    id="Today"
                    role="tabpanel"
                    aria-labelledby="Today-tab"
                  >
                    <!-- today-tabs-start -->
                    <div class="todaytab-area">
                      <div class="row">
                        <div class="col-sm-6 col-md-4 col-lg-3 border-right">
                          <!-- Summary-tabs -->
                          <div class="samary-tabs">
                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                              <li class="nav-item" role="presentation">
                                <a
                                  class="nav-link active"
                                  id="Summary-tab"
                                  data-toggle="tab"
                                  href="#Summary"
                                  role="tab"
                                  aria-controls="Summary"
                                  aria-selected="true"
                                  >Summary</a
                                >
                              </li>
                              <li class="nav-item" role="presentation">
                                <a
                                  class="nav-link"
                                  id="Capacity-tab"
                                  data-toggle="tab"
                                  href="#Capacity"
                                  role="tab"
                                  aria-controls="Capacity"
                                  aria-selected="false"
                                  >Capacity</a
                                >
                              </li>
                              <li class="nav-item" role="presentation">
                                <a
                                  class="nav-link"
                                  id="Text-tab"
                                  data-toggle="tab"
                                  href="#Text"
                                  role="tab"
                                  aria-controls="Text"
                                  aria-selected="false"
                                  >Text</a
                                >
                              </li>
                            </ul>
                            <div class="tab-content" id="myTabContent">
                              <div
                                class="tab-pane fade show active"
                                id="Summary"
                                role="tabpanel"
                                aria-labelledby="Summary-tab"
                              >
                                <!-- summary-table   -->
                                <div class="sammary-table">
                                  <table class="table">
                                    <thead>
                                      <tr>
                                        <th>Action name</th>
                                        <th>View</th>
                                        <th>All</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>Carrry Overs</td>
                                        <td>0</td>
                                        <td>0</td>
                                      </tr>
                                      <tr>
                                        <td>Extended</td>
                                        <td>0</td>
                                        <td>0</td>
                                      </tr>
                                      <tr>
                                        <td>Totals</td>
                                        <td>0</td>
                                        <td>0</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <!-- summary-table   -->
                                <!-- summrty-shec -->
                                <div class="summrty-shec">
                                  <h4>Schedule</h4>
                                  <ul>
                                    <li>
                                      <p>08:00 AM</p>
                                      <div class="progress">
                                        <div
                                          class="progress-bar"
                                          role="progressbar"
                                          style="width: 15%"
                                          aria-valuenow="15"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                        <div
                                          class="progress-bar bg-success"
                                          role="progressbar"
                                          style="width: 30%"
                                          aria-valuenow="30"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </li>
                                    <li>
                                      <p>08:00 AM</p>
                                      <div class="progress">
                                        <div
                                          class="progress-bar"
                                          role="progressbar"
                                          style="width: 35%"
                                          aria-valuenow="15"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                        <div
                                          class="progress-bar bg-success"
                                          role="progressbar"
                                          style="width: 30%"
                                          aria-valuenow="30"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </li>
                                    <li>
                                      <p>08:00 AM</p>
                                      <div class="progress">
                                        <div
                                          class="progress-bar"
                                          role="progressbar"
                                          style="width: 19%"
                                          aria-valuenow="15"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                        <div
                                          class="progress-bar bg-success"
                                          role="progressbar"
                                          style="width: 39%"
                                          aria-valuenow="30"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </li>
                                    <li>
                                      <p>08:00 AM</p>
                                      <div class="progress">
                                        <div
                                          class="progress-bar"
                                          role="progressbar"
                                          style="width: 35%"
                                          aria-valuenow="15"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                        <div
                                          class="progress-bar bg-success"
                                          role="progressbar"
                                          style="width: 30%"
                                          aria-valuenow="30"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </li>
                                    <li>
                                      <p>08:00 AM</p>
                                      <div class="progress">
                                        <div
                                          class="progress-bar"
                                          role="progressbar"
                                          style="width: 15%"
                                          aria-valuenow="15"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                        <div
                                          class="progress-bar bg-success"
                                          role="progressbar"
                                          style="width: 50%"
                                          aria-valuenow="30"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </li>
                                    <li>
                                      <p>08:00 AM</p>
                                      <div class="progress">
                                        <div
                                          class="progress-bar"
                                          role="progressbar"
                                          style="width: 15%"
                                          aria-valuenow="15"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                        <div
                                          class="progress-bar bg-success"
                                          role="progressbar"
                                          style="width: 30%"
                                          aria-valuenow="30"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </li>
                                  </ul>
                                  <div class="symobles">
                                    <ul>
                                      <li>
                                        <span class="symb1"></span>
                                        Filterd Results
                                      </li>
                                      <li>
                                        <span class="symb2"></span>
                                        Walk-Ins (Actual)
                                      </li>
                                      <li>
                                        <span class="symb3"></span>
                                        Appointments
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <!-- summrty-shec -->
                              </div>
                              <div
                                class="tab-pane fade"
                                id="Capacity"
                                role="tabpanel"
                                aria-labelledby="Capacity-tab"
                              ></div>
                              <div
                                class="tab-pane fade"
                                id="Text"
                                role="tabpanel"
                                aria-labelledby="Text-tab"
                              ></div>
                            </div>
                          </div>
                          <!-- Summary-tabs -->
                        </div>
                        <!-- week-right -->
                        <div class="col-sm-6 col-md-8 col-lg-9">
                          <!-- todaytime-tabs -->
                          <div class="todaytime-tabs">
                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                              <li class="nav-item" role="presentation">
                                <a
                                  class="nav-link active"
                                  id="Time-tab"
                                  data-toggle="tab"
                                  href="#Time"
                                  role="tab"
                                  aria-controls="Time"
                                  aria-selected="true"
                                  >Time</a
                                >
                              </li>
                              <li class="nav-item" role="presentation">
                                <a
                                  class="nav-link"
                                  id="Advisor-tab"
                                  data-toggle="tab"
                                  href="#Advisor"
                                  role="tab"
                                  aria-controls="Advisor"
                                  aria-selected="false"
                                  >Advisor</a
                                >
                              </li>
                              <li class="nav-item" role="presentation">
                                <a
                                  class="nav-link"
                                  id="Team-tab"
                                  data-toggle="tab"
                                  href="#Team"
                                  role="tab"
                                  aria-controls="Team"
                                  aria-selected="false"
                                  >Team</a
                                >
                              </li>
                              <li class="nav-item" role="presentation">
                                <a
                                  class="nav-link"
                                  id="Status-tab"
                                  data-toggle="tab"
                                  href="#Status"
                                  role="tab"
                                  aria-controls="Status"
                                  aria-selected="false"
                                  >Status</a
                                >
                              </li>
                            </ul>
                            <!-- titmeline-filter -->
                            <div class="titmeline-filter">
                              <div class="timeline">
                                <button type="button" class="current">
                                  <span class="today">Today</span>
                                </button>
                                <button type="button">
                                  <span class="today">This month</span>
                                </button>
                                <button type="button">
                                  <input
                                    type="text"
                                    name="datefilter"
                                    value=""
                                  />
                                  <span class="month">Custom day</span>
                                </button>
                                <button type="button" class="add-appi">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="8"
                                    viewBox="0 0 12 8"
                                    fill="none"
                                  >
                                    <path
                                      d="M4.66667 8H7.33333V6.66667H4.66667V8ZM0 0V1.33333H12V0H0ZM2 4.66667H10V3.33333H2V4.66667Z"
                                      fill="#3151A1"
                                    />
                                  </svg>
                                  <span class="month">Filter</span>
                                </button>
                              </div>
                            </div>
                            <!-- titmeline-filter -->
                            <div class="tab-content" id="myTabContent">
                              <div
                                class="tab-pane fade show active"
                                id="Time"
                                role="tabpanel"
                                aria-labelledby="Time-tab"
                              >
                                <!-- slider -->
                                <div class="">
                                  <carousel>
                                    <!-- items -->
                                      <div class="items">
                                      <!-- daytime-area -->
                                      <div class="daytime-area">
                                        <div class="title-time">
                                          <h4>08:00 AM</h4>
                                          <a class="full-btn" href="#"
                                            >Full
                                            <!-- <img
                                            style="display: initial;"
                                              class="img-fluid"
                                              src="../../assets/img/arrow-d.svg"
                                              alt=""
                                          /> -->
                                          </a>
                                        </div>
                                        <div
                                          class="all-task simplebar"
                                          id="myElement16"
                                        >
                                          <div
                                            class="
                                              sortable
                                              connectedSortable
                                              ui-sortable
                                            "
                                          >
                                            <!-- accordion-start  -->
                                            <div class="">
                                              <div class="form-row">
                                                <div class="col-xl-2">
                                                  <div class="datetime">
                                                    <p
                                                      data-toggle="tooltip"
                                                      data-placement="top"
                                                      title="Drag Left Or Right"
                                                    >
                                                      9:00
                                                    </p>
                                                  </div>
                                                </div>
                                                <div class="col-xl-10">
                                                  <div
                                                    class="accordion"
                                                    id="accordionExample4"
                                                  >
                                                    <div class="card">
                                                      <div
                                                        class="
                                                          card-header
                                                          green-meeting
                                                        "
                                                        id="headingOne21"
                                                      >
                                                        <h2 class="mb-0">
                                                          <button
                                                            class="
                                                              btn
                                                              btn-link
                                                              btn-block
                                                              text-left
                                                              collapsed
                                                            "
                                                            type="button"
                                                            data-toggle="collapse"
                                                            data-target="#collapseOne21"
                                                            aria-expanded="true"
                                                            aria-controls="collapseOne21"
                                                          >
                                                            2015 Hyundai Genesis
                                                            <p>Thomas Merlin</p>
                                                            <div
                                                              class="appo-menu"
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a
                                                                    class="okay"
                                                                    href="#"
                                                                    ><img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/call-green.svg"
                                                                      alt=""
                                                                  /></a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                          </button>
                                                        </h2>
                                                      </div>
                                                      <div
                                                        id="collapseOne21"
                                                        class="collapse"
                                                        aria-labelledby="headingOne21"
                                                        data-parent="#accordionExample4"
                                                      >
                                                        <div class="card-body">
                                                          <!-- metting-collap -->
                                                          <div
                                                            class="
                                                              metting-collap
                                                            "
                                                          >
                                                            <div
                                                              class="
                                                                contact-info
                                                              "
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a href="#">
                                                                    Contact
                                                                    <p>
                                                                      (876)
                                                                      231-2512
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Battery
                                                                    Service
                                                                    <p>
                                                                      Car won’t
                                                                      start when
                                                                      battery is
                                                                      dead
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Other
                                                                    Diagnosis
                                                                    <p>
                                                                      Lights not
                                                                      working
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>
                                                                Randy Rocket
                                                                <span
                                                                  >60,000
                                                                  mi</span
                                                                >
                                                              </h3>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>Drop-Off</h3>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                            <div
                                                              class="
                                                                not-arrived
                                                              "
                                                            >
                                                              <div
                                                                class="arrived"
                                                              >
                                                                <h4>
                                                                  Not Arrived
                                                                  <img
                                                                    class="
                                                                      img-fluid
                                                                      ddg
                                                                    "
                                                                    src="assets/img/arrowd.svg"
                                                                    alt=""
                                                                  />
                                                                </h4>
                                                                <div
                                                                  class="
                                                                    arrived-con
                                                                  "
                                                                >
                                                                  <div
                                                                    class="
                                                                      ar-note
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Notes :
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        note-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                  <div
                                                                    class="
                                                                      ar-comp
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Completion
                                                                      :
                                                                      <span
                                                                        >06/18
                                                                        5:15
                                                                        PM</span
                                                                      >
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        comp-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                          </div>
                                                          <!-- metting-collap -->
                                                          <!-- meeting-footer -->
                                                          <div
                                                            class="
                                                              meeting-footer
                                                            "
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-mess.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cele.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a
                                                                  href="services-info.html"
                                                                  ><img
                                                                    src="assets/img/ser-user.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cars.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <!-- meeting-footer -->
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- accordion-end -->
                                            <!-- accordion-start  -->
                                            <div class="">
                                              <div class="form-row">
                                                <div class="col-xl-2">
                                                  <div class="datetime">
                                                    <p
                                                      data-toggle="tooltip"
                                                      data-placement="top"
                                                      title="Drag Left Or Right"
                                                    >
                                                      9:00
                                                    </p>
                                                  </div>
                                                </div>
                                                <div class="col-xl-10">
                                                  <div
                                                    class="accordion"
                                                    id="accordionExample5"
                                                  >
                                                    <div class="card">
                                                      <div
                                                        class="
                                                          card-header
                                                          blue-meeting
                                                        "
                                                        id="headingOne22"
                                                      >
                                                        <h2 class="mb-0">
                                                          <button
                                                            class="
                                                              btn
                                                              btn-link
                                                              btn-block
                                                              text-left
                                                              collapsed
                                                            "
                                                            type="button"
                                                            data-toggle="collapse"
                                                            data-target="#collapseOne22"
                                                            aria-expanded="true"
                                                            aria-controls="collapseOne22"
                                                          >
                                                            2015 Hyundai Genesis
                                                            <p>Thomas Merlin</p>
                                                            <div
                                                              class="appo-menu"
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a
                                                                    class="okay"
                                                                    href="#"
                                                                    ><img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/blie-wl.svg"
                                                                      alt=""
                                                                  /></a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                          </button>
                                                        </h2>
                                                      </div>
                                                      <div
                                                        id="collapseOne22"
                                                        class="collapse"
                                                        aria-labelledby="headingOne22"
                                                        data-parent="#accordionExample5"
                                                      >
                                                        <div class="card-body">
                                                          <!-- metting-collap -->
                                                          <div
                                                            class="
                                                              metting-collap
                                                            "
                                                          >
                                                            <div
                                                              class="
                                                                contact-info
                                                              "
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a href="#">
                                                                    Contact
                                                                    <p>
                                                                      (876)
                                                                      231-2512
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Battery
                                                                    Service
                                                                    <p>
                                                                      Car won’t
                                                                      start when
                                                                      battery is
                                                                      dead
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Other
                                                                    Diagnosis
                                                                    <p>
                                                                      Lights not
                                                                      working
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>
                                                                Randy Rocket
                                                                <span
                                                                  >60,000
                                                                  mi</span
                                                                >
                                                              </h3>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>Drop-Off</h3>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                            <div
                                                              class="
                                                                not-arrived
                                                              "
                                                            >
                                                              <div
                                                                class="arrived"
                                                              >
                                                                <h4>
                                                                  Not Arrived
                                                                  <img
                                                                    class="
                                                                      img-fluid
                                                                      ddg
                                                                    "
                                                                    src="assets/img/arrowd.svg"
                                                                    alt=""
                                                                  />
                                                                </h4>
                                                                <div
                                                                  class="
                                                                    arrived-con
                                                                  "
                                                                >
                                                                  <div
                                                                    class="
                                                                      ar-note
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Notes :
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        note-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                  <div
                                                                    class="
                                                                      ar-comp
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Completion
                                                                      :
                                                                      <span
                                                                        >06/18
                                                                        5:15
                                                                        PM</span
                                                                      >
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        comp-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                          </div>
                                                          <!-- metting-collap -->
                                                          <!-- meeting-footer -->
                                                          <div
                                                            class="
                                                              meeting-footer
                                                            "
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-mess.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cele.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a
                                                                  href="services-info.html"
                                                                  ><img
                                                                    src="assets/img/ser-user.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cars.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <!-- meeting-footer -->
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- accordion-end -->
                                            <!-- accordion-start  -->
                                            <div class="">
                                              <div class="form-row">
                                                <div class="col-xl-2">
                                                  <div class="datetime">
                                                    <p
                                                      data-toggle="tooltip"
                                                      data-placement="top"
                                                      title="Drag Left Or Right"
                                                    >
                                                      9:00
                                                    </p>
                                                  </div>
                                                </div>
                                                <div class="col-xl-10">
                                                  <div
                                                    class="accordion"
                                                    id="accordionExample6"
                                                  >
                                                    <div class="card">
                                                      <div
                                                        class="
                                                          card-header
                                                          red-meeting
                                                        "
                                                        id="headingOne33"
                                                      >
                                                        <h2 class="mb-0">
                                                          <button
                                                            class="
                                                              btn
                                                              btn-link
                                                              btn-block
                                                              text-left
                                                              collapsed
                                                            "
                                                            type="button"
                                                            data-toggle="collapse"
                                                            data-target="#collapseOne33"
                                                            aria-expanded="true"
                                                            aria-controls="collapseOne33"
                                                          >
                                                            2015 Hyundai Genesis
                                                            <p>Thomas Merlin</p>
                                                            <div
                                                              class="appo-menu"
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a
                                                                    class="okay"
                                                                    href="#"
                                                                    ><img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/red-h.svg"
                                                                      alt=""
                                                                  /></a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                          </button>
                                                        </h2>
                                                      </div>
                                                      <div
                                                        id="collapseOne33"
                                                        class="collapse"
                                                        aria-labelledby="headingOne33"
                                                        data-parent="#accordionExample6"
                                                      >
                                                        <div class="card-body">
                                                          <!-- metting-collap -->
                                                          <div
                                                            class="
                                                              metting-collap
                                                            "
                                                          >
                                                            <div
                                                              class="
                                                                contact-info
                                                              "
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a href="#">
                                                                    Contact
                                                                    <p>
                                                                      (876)
                                                                      231-2512
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Battery
                                                                    Service
                                                                    <p>
                                                                      Car won’t
                                                                      start when
                                                                      battery is
                                                                      dead
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Other
                                                                    Diagnosis
                                                                    <p>
                                                                      Lights not
                                                                      working
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>
                                                                Randy Rocket
                                                                <span
                                                                  >60,000
                                                                  mi</span
                                                                >
                                                              </h3>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>Drop-Off</h3>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                            <div
                                                              class="
                                                                not-arrived
                                                              "
                                                            >
                                                              <div
                                                                class="arrived"
                                                              >
                                                                <h4>
                                                                  Not Arrived
                                                                  <img
                                                                    class="
                                                                      img-fluid
                                                                      ddg
                                                                    "
                                                                    src="assets/img/arrowd.svg"
                                                                    alt=""
                                                                  />
                                                                </h4>
                                                                <div
                                                                  class="
                                                                    arrived-con
                                                                  "
                                                                >
                                                                  <div
                                                                    class="
                                                                      ar-note
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Notes :
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        note-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                  <div
                                                                    class="
                                                                      ar-comp
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Completion
                                                                      :
                                                                      <span
                                                                        >06/18
                                                                        5:15
                                                                        PM</span
                                                                      >
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        comp-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                          </div>
                                                          <!-- metting-collap -->
                                                          <!-- meeting-footer -->
                                                          <div
                                                            class="
                                                              meeting-footer
                                                            "
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-mess.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cele.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a
                                                                  href="services-info.html"
                                                                  ><img
                                                                    src="assets/img/ser-user.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cars.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <!-- meeting-footer -->
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- accordion-end -->
                                          </div>
                                        </div>
                                      </div>
                                      <!-- daytime-area -->
                                    </div>
                                    <!-- items -->
                                    <!-- items -->
                                    <div class="items">
                                      <!-- daytime-area -->
                                      <div class="daytime-area">
                                        <div class="title-time">
                                          <h4>08:00 AM</h4>
                                          <a class="full-btn" href="#"
                                            >Full
                                            <!-- <img
                                              class="img-fluid"
                                              src="../../assets/img/arrow-d.svg"
                                              alt=""
                                          /> -->
                                          </a>
                                        </div>
                                        <div
                                          class="all-task simplebar"
                                          id="myElement16"
                                        >
                                          <div
                                            class="
                                              sortable
                                              connectedSortable
                                              ui-sortable
                                            "
                                          >
                                            <!-- accordion-start  -->
                                            <div class="">
                                              <div class="form-row">
                                                <div class="col-xl-2">
                                                  <div class="datetime">
                                                    <p
                                                      data-toggle="tooltip"
                                                      data-placement="top"
                                                      title="Drag Left Or Right"
                                                    >
                                                      9:00
                                                    </p>
                                                  </div>
                                                </div>
                                                <div class="col-xl-10">
                                                  <div
                                                    class="accordion"
                                                    id="accordionExample4"
                                                  >
                                                    <div class="card">
                                                      <div
                                                        class="
                                                          card-header
                                                          green-meeting
                                                        "
                                                        id="headingOne21"
                                                      >
                                                        <h2 class="mb-0">
                                                          <button
                                                            class="
                                                              btn
                                                              btn-link
                                                              btn-block
                                                              text-left
                                                              collapsed
                                                            "
                                                            type="button"
                                                            data-toggle="collapse"
                                                            data-target="#collapseOne21"
                                                            aria-expanded="true"
                                                            aria-controls="collapseOne21"
                                                          >
                                                            2015 Hyundai Genesis
                                                            <p>Thomas Merlin</p>
                                                            <div
                                                              class="appo-menu"
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a
                                                                    class="okay"
                                                                    href="#"
                                                                    ><img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/call-green.svg"
                                                                      alt=""
                                                                  /></a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                          </button>
                                                        </h2>
                                                      </div>
                                                      <div
                                                        id="collapseOne21"
                                                        class="collapse"
                                                        aria-labelledby="headingOne21"
                                                        data-parent="#accordionExample4"
                                                      >
                                                        <div class="card-body">
                                                          <!-- metting-collap -->
                                                          <div
                                                            class="
                                                              metting-collap
                                                            "
                                                          >
                                                            <div
                                                              class="
                                                                contact-info
                                                              "
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a href="#">
                                                                    Contact
                                                                    <p>
                                                                      (876)
                                                                      231-2512
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Battery
                                                                    Service
                                                                    <p>
                                                                      Car won’t
                                                                      start when
                                                                      battery is
                                                                      dead
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Other
                                                                    Diagnosis
                                                                    <p>
                                                                      Lights not
                                                                      working
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>
                                                                Randy Rocket
                                                                <span
                                                                  >60,000
                                                                  mi</span
                                                                >
                                                              </h3>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>Drop-Off</h3>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                            <div
                                                              class="
                                                                not-arrived
                                                              "
                                                            >
                                                              <div
                                                                class="arrived"
                                                              >
                                                                <h4>
                                                                  Not Arrived
                                                                  <img
                                                                    class="
                                                                      img-fluid
                                                                      ddg
                                                                    "
                                                                    src="assets/img/arrowd.svg"
                                                                    alt=""
                                                                  />
                                                                </h4>
                                                                <div
                                                                  class="
                                                                    arrived-con
                                                                  "
                                                                >
                                                                  <div
                                                                    class="
                                                                      ar-note
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Notes :
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        note-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                  <div
                                                                    class="
                                                                      ar-comp
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Completion
                                                                      :
                                                                      <span
                                                                        >06/18
                                                                        5:15
                                                                        PM</span
                                                                      >
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        comp-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                          </div>
                                                          <!-- metting-collap -->
                                                          <!-- meeting-footer -->
                                                          <div
                                                            class="
                                                              meeting-footer
                                                            "
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-mess.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cele.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a
                                                                  href="services-info.html"
                                                                  ><img
                                                                    src="assets/img/ser-user.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cars.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <!-- meeting-footer -->
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- accordion-end -->
                                            <!-- accordion-start  -->
                                            <div class="">
                                              <div class="form-row">
                                                <div class="col-xl-2">
                                                  <div class="datetime">
                                                    <p
                                                      data-toggle="tooltip"
                                                      data-placement="top"
                                                      title="Drag Left Or Right"
                                                    >
                                                      9:00
                                                    </p>
                                                  </div>
                                                </div>
                                                <div class="col-xl-10">
                                                  <div
                                                    class="accordion"
                                                    id="accordionExample5"
                                                  >
                                                    <div class="card">
                                                      <div
                                                        class="
                                                          card-header
                                                          blue-meeting
                                                        "
                                                        id="headingOne22"
                                                      >
                                                        <h2 class="mb-0">
                                                          <button
                                                            class="
                                                              btn
                                                              btn-link
                                                              btn-block
                                                              text-left
                                                              collapsed
                                                            "
                                                            type="button"
                                                            data-toggle="collapse"
                                                            data-target="#collapseOne22"
                                                            aria-expanded="true"
                                                            aria-controls="collapseOne22"
                                                          >
                                                            2015 Hyundai Genesis
                                                            <p>Thomas Merlin</p>
                                                            <div
                                                              class="appo-menu"
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a
                                                                    class="okay"
                                                                    href="#"
                                                                    ><img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/blie-wl.svg"
                                                                      alt=""
                                                                  /></a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                          </button>
                                                        </h2>
                                                      </div>
                                                      <div
                                                        id="collapseOne22"
                                                        class="collapse"
                                                        aria-labelledby="headingOne22"
                                                        data-parent="#accordionExample5"
                                                      >
                                                        <div class="card-body">
                                                          <!-- metting-collap -->
                                                          <div
                                                            class="
                                                              metting-collap
                                                            "
                                                          >
                                                            <div
                                                              class="
                                                                contact-info
                                                              "
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a href="#">
                                                                    Contact
                                                                    <p>
                                                                      (876)
                                                                      231-2512
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Battery
                                                                    Service
                                                                    <p>
                                                                      Car won’t
                                                                      start when
                                                                      battery is
                                                                      dead
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Other
                                                                    Diagnosis
                                                                    <p>
                                                                      Lights not
                                                                      working
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>
                                                                Randy Rocket
                                                                <span
                                                                  >60,000
                                                                  mi</span
                                                                >
                                                              </h3>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>Drop-Off</h3>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                            <div
                                                              class="
                                                                not-arrived
                                                              "
                                                            >
                                                              <div
                                                                class="arrived"
                                                              >
                                                                <h4>
                                                                  Not Arrived
                                                                  <img
                                                                    class="
                                                                      img-fluid
                                                                      ddg
                                                                    "
                                                                    src="assets/img/arrowd.svg"
                                                                    alt=""
                                                                  />
                                                                </h4>
                                                                <div
                                                                  class="
                                                                    arrived-con
                                                                  "
                                                                >
                                                                  <div
                                                                    class="
                                                                      ar-note
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Notes :
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        note-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                  <div
                                                                    class="
                                                                      ar-comp
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Completion
                                                                      :
                                                                      <span
                                                                        >06/18
                                                                        5:15
                                                                        PM</span
                                                                      >
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        comp-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                          </div>
                                                          <!-- metting-collap -->
                                                          <!-- meeting-footer -->
                                                          <div
                                                            class="
                                                              meeting-footer
                                                            "
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-mess.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cele.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a
                                                                  href="services-info.html"
                                                                  ><img
                                                                    src="assets/img/ser-user.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cars.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <!-- meeting-footer -->
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- accordion-end -->
                                            <!-- accordion-start  -->
                                            <div class="">
                                              <div class="form-row">
                                                <div class="col-xl-2">
                                                  <div class="datetime">
                                                    <p
                                                      data-toggle="tooltip"
                                                      data-placement="top"
                                                      title="Drag Left Or Right"
                                                    >
                                                      9:00
                                                    </p>
                                                  </div>
                                                </div>
                                                <div class="col-xl-10">
                                                  <div
                                                    class="accordion"
                                                    id="accordionExample6"
                                                  >
                                                    <div class="card">
                                                      <div
                                                        class="
                                                          card-header
                                                          red-meeting
                                                        "
                                                        id="headingOne33"
                                                      >
                                                        <h2 class="mb-0">
                                                          <button
                                                            class="
                                                              btn
                                                              btn-link
                                                              btn-block
                                                              text-left
                                                              collapsed
                                                            "
                                                            type="button"
                                                            data-toggle="collapse"
                                                            data-target="#collapseOne33"
                                                            aria-expanded="true"
                                                            aria-controls="collapseOne33"
                                                          >
                                                            2015 Hyundai Genesis
                                                            <p>Thomas Merlin</p>
                                                            <div
                                                              class="appo-menu"
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a
                                                                    class="okay"
                                                                    href="#"
                                                                    ><img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/red-h.svg"
                                                                      alt=""
                                                                  /></a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                          </button>
                                                        </h2>
                                                      </div>
                                                      <div
                                                        id="collapseOne33"
                                                        class="collapse"
                                                        aria-labelledby="headingOne33"
                                                        data-parent="#accordionExample6"
                                                      >
                                                        <div class="card-body">
                                                          <!-- metting-collap -->
                                                          <div
                                                            class="
                                                              metting-collap
                                                            "
                                                          >
                                                            <div
                                                              class="
                                                                contact-info
                                                              "
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a href="#">
                                                                    Contact
                                                                    <p>
                                                                      (876)
                                                                      231-2512
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Battery
                                                                    Service
                                                                    <p>
                                                                      Car won’t
                                                                      start when
                                                                      battery is
                                                                      dead
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Other
                                                                    Diagnosis
                                                                    <p>
                                                                      Lights not
                                                                      working
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>
                                                                Randy Rocket
                                                                <span
                                                                  >60,000
                                                                  mi</span
                                                                >
                                                              </h3>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>Drop-Off</h3>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                            <div
                                                              class="
                                                                not-arrived
                                                              "
                                                            >
                                                              <div
                                                                class="arrived"
                                                              >
                                                                <h4>
                                                                  Not Arrived
                                                                  <img
                                                                    class="
                                                                      img-fluid
                                                                      ddg
                                                                    "
                                                                    src="assets/img/arrowd.svg"
                                                                    alt=""
                                                                  />
                                                                </h4>
                                                                <div
                                                                  class="
                                                                    arrived-con
                                                                  "
                                                                >
                                                                  <div
                                                                    class="
                                                                      ar-note
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Notes :
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        note-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                  <div
                                                                    class="
                                                                      ar-comp
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Completion
                                                                      :
                                                                      <span
                                                                        >06/18
                                                                        5:15
                                                                        PM</span
                                                                      >
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        comp-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                          </div>
                                                          <!-- metting-collap -->
                                                          <!-- meeting-footer -->
                                                          <div
                                                            class="
                                                              meeting-footer
                                                            "
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-mess.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cele.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a
                                                                  href="services-info.html"
                                                                  ><img
                                                                    src="assets/img/ser-user.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cars.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <!-- meeting-footer -->
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- accordion-end -->
                                          </div>
                                        </div>
                                      </div>
                                      <!-- daytime-area -->
                                    </div>
                                    <!-- items -->
                                    <!-- items -->
                                    <div class="items">
                                      <!-- daytime-area -->
                                      <div class="daytime-area">
                                        <div class="title-time">
                                          <h4>11:00 AM</h4>
                                          <a class="full-btn" href="#"
                                            >Full
                                            <!-- <img
                                              class="img-fluid"
                                              src="../../assets/img/arrow-d.svg"
                                              alt=""
                                          /> -->
                                          </a>
                                        </div>
                                        <div
                                          class="all-task simplebar"
                                          id="myElement17"
                                        >
                                          <div
                                            class="
                                              sortable
                                              connectedSortable
                                              ui-sortable
                                            "
                                          >
                                            <!-- accordion-start  -->
                                            <div class="">
                                              <div class="form-row">
                                                <div class="col-xl-2">
                                                  <div class="datetime">
                                                    <p
                                                      data-toggle="tooltip"
                                                      data-placement="top"
                                                      title="Drag Left Or Right"
                                                    >
                                                      9:00
                                                    </p>
                                                  </div>
                                                </div>
                                                <div class="col-xl-10">
                                                  <div
                                                    class="accordion"
                                                    id="accordionExample7"
                                                  >
                                                    <div class="card">
                                                      <div
                                                        class="
                                                          card-header
                                                          green-meeting
                                                        "
                                                        id="headingOne23"
                                                      >
                                                        <h2 class="mb-0">
                                                          <button
                                                            class="
                                                              btn
                                                              btn-link
                                                              btn-block
                                                              text-left
                                                              collapsed
                                                            "
                                                            type="button"
                                                            data-toggle="collapse"
                                                            data-target="#collapseOne23"
                                                            aria-expanded="true"
                                                            aria-controls="collapseOne23"
                                                          >
                                                            2015 Hyundai Genesis
                                                            <p>Thomas Merlin</p>
                                                            <div
                                                              class="appo-menu"
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a
                                                                    class="okay"
                                                                    href="#"
                                                                    ><img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/call-green.svg"
                                                                      alt=""
                                                                  /></a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                          </button>
                                                        </h2>
                                                      </div>
                                                      <div
                                                        id="collapseOne23"
                                                        class="collapse"
                                                        aria-labelledby="headingOne23"
                                                        data-parent="#accordionExample7"
                                                      >
                                                        <div class="card-body">
                                                          <!-- metting-collap -->
                                                          <div
                                                            class="
                                                              metting-collap
                                                            "
                                                          >
                                                            <div
                                                              class="
                                                                contact-info
                                                              "
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a href="#">
                                                                    Contact
                                                                    <p>
                                                                      (876)
                                                                      231-2512
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Battery
                                                                    Service
                                                                    <p>
                                                                      Car won’t
                                                                      start when
                                                                      battery is
                                                                      dead
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Other
                                                                    Diagnosis
                                                                    <p>
                                                                      Lights not
                                                                      working
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>
                                                                Randy Rocket
                                                                <span
                                                                  >60,000
                                                                  mi</span
                                                                >
                                                              </h3>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>Drop-Off</h3>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                            <div
                                                              class="
                                                                not-arrived
                                                              "
                                                            >
                                                              <div
                                                                class="arrived"
                                                              >
                                                                <h4>
                                                                  Not Arrived
                                                                  <img
                                                                    class="
                                                                      img-fluid
                                                                      ddg
                                                                    "
                                                                    src="assets/img/arrowd.svg"
                                                                    alt=""
                                                                  />
                                                                </h4>
                                                                <div
                                                                  class="
                                                                    arrived-con
                                                                  "
                                                                >
                                                                  <div
                                                                    class="
                                                                      ar-note
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Notes :
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        note-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                  <div
                                                                    class="
                                                                      ar-comp
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Completion
                                                                      :
                                                                      <span
                                                                        >06/18
                                                                        5:15
                                                                        PM</span
                                                                      >
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        comp-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                          </div>
                                                          <!-- metting-collap -->
                                                          <!-- meeting-footer -->
                                                          <div
                                                            class="
                                                              meeting-footer
                                                            "
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-mess.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cele.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a
                                                                  href="services-info.html"
                                                                  ><img
                                                                    src="assets/img/ser-user.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cars.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <!-- meeting-footer -->
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- accordion-end -->
                                            <!-- accordion-start  -->
                                            <div class="">
                                              <div class="form-row">
                                                <div class="col-xl-2">
                                                  <div class="datetime">
                                                    <p
                                                      data-toggle="tooltip"
                                                      data-placement="top"
                                                      title="Drag Left Or Right"
                                                    >
                                                      9:00
                                                    </p>
                                                  </div>
                                                </div>
                                                <div class="col-xl-10">
                                                  <div
                                                    class="accordion"
                                                    id="accordionExample8"
                                                  >
                                                    <div class="card">
                                                      <div
                                                        class="
                                                          card-header
                                                          blue-meeting
                                                        "
                                                        id="headingOne24"
                                                      >
                                                        <h2 class="mb-0">
                                                          <button
                                                            class="
                                                              btn
                                                              btn-link
                                                              btn-block
                                                              text-left
                                                              collapsed
                                                            "
                                                            type="button"
                                                            data-toggle="collapse"
                                                            data-target="#collapseOne24"
                                                            aria-expanded="true"
                                                            aria-controls="collapseOne24"
                                                          >
                                                            2015 Hyundai Genesis
                                                            <p>Thomas Merlin</p>
                                                            <div
                                                              class="appo-menu"
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a
                                                                    class="okay"
                                                                    href="#"
                                                                    ><img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/blie-wl.svg"
                                                                      alt=""
                                                                  /></a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                          </button>
                                                        </h2>
                                                      </div>
                                                      <div
                                                        id="collapseOne24"
                                                        class="collapse"
                                                        aria-labelledby="headingOne24"
                                                        data-parent="#accordionExample8"
                                                      >
                                                        <div class="card-body">
                                                          <!-- metting-collap -->
                                                          <div
                                                            class="
                                                              metting-collap
                                                            "
                                                          >
                                                            <div
                                                              class="
                                                                contact-info
                                                              "
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a href="#">
                                                                    Contact
                                                                    <p>
                                                                      (876)
                                                                      231-2512
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Battery
                                                                    Service
                                                                    <p>
                                                                      Car won’t
                                                                      start when
                                                                      battery is
                                                                      dead
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Other
                                                                    Diagnosis
                                                                    <p>
                                                                      Lights not
                                                                      working
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>
                                                                Randy Rocket
                                                                <span
                                                                  >60,000
                                                                  mi</span
                                                                >
                                                              </h3>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>Drop-Off</h3>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                            <div
                                                              class="
                                                                not-arrived
                                                              "
                                                            >
                                                              <div
                                                                class="arrived"
                                                              >
                                                                <h4>
                                                                  Not Arrived
                                                                  <img
                                                                    class="
                                                                      img-fluid
                                                                      ddg
                                                                    "
                                                                    src="assets/img/arrowd.svg"
                                                                    alt=""
                                                                  />
                                                                </h4>
                                                                <div
                                                                  class="
                                                                    arrived-con
                                                                  "
                                                                >
                                                                  <div
                                                                    class="
                                                                      ar-note
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Notes :
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        note-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                  <div
                                                                    class="
                                                                      ar-comp
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Completion
                                                                      :
                                                                      <span
                                                                        >06/18
                                                                        5:15
                                                                        PM</span
                                                                      >
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        comp-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                          </div>
                                                          <!-- metting-collap -->
                                                          <!-- meeting-footer -->
                                                          <div
                                                            class="
                                                              meeting-footer
                                                            "
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-mess.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cele.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a
                                                                  href="services-info.html"
                                                                  ><img
                                                                    src="assets/img/ser-user.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cars.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <!-- meeting-footer -->
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- accordion-end -->
                                            <!-- accordion-start  -->
                                            <div class="">
                                              <div class="form-row">
                                                <div class="col-xl-2">
                                                  <div class="datetime">
                                                    <p
                                                      data-toggle="tooltip"
                                                      data-placement="top"
                                                      title="Drag Left Or Right"
                                                    >
                                                      9:00
                                                    </p>
                                                  </div>
                                                </div>
                                                <div class="col-xl-10">
                                                  <div
                                                    class="accordion"
                                                    id="accordionExample9"
                                                  >
                                                    <div class="card">
                                                      <div
                                                        class="
                                                          card-header
                                                          red-meeting
                                                        "
                                                        id="headingOne35"
                                                      >
                                                        <h2 class="mb-0">
                                                          <button
                                                            class="
                                                              btn
                                                              btn-link
                                                              btn-block
                                                              text-left
                                                              collapsed
                                                            "
                                                            type="button"
                                                            data-toggle="collapse"
                                                            data-target="#collapseOne35"
                                                            aria-expanded="true"
                                                            aria-controls="collapseOne35"
                                                          >
                                                            2015 Hyundai Genesis
                                                            <p>Thomas Merlin</p>
                                                            <div
                                                              class="appo-menu"
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a
                                                                    class="okay"
                                                                    href="#"
                                                                    ><img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/red-h.svg"
                                                                      alt=""
                                                                  /></a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                          </button>
                                                        </h2>
                                                      </div>
                                                      <div
                                                        id="collapseOne35"
                                                        class="collapse"
                                                        aria-labelledby="headingOne35"
                                                        data-parent="#accordionExample9"
                                                      >
                                                        <div class="card-body">
                                                          <!-- metting-collap -->
                                                          <div
                                                            class="
                                                              metting-collap
                                                            "
                                                          >
                                                            <div
                                                              class="
                                                                contact-info
                                                              "
                                                            >
                                                              <ul>
                                                                <li>
                                                                  <a href="#">
                                                                    Contact
                                                                    <p>
                                                                      (876)
                                                                      231-2512
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Battery
                                                                    Service
                                                                    <p>
                                                                      Car won’t
                                                                      start when
                                                                      battery is
                                                                      dead
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                                <li>
                                                                  <a href="#">
                                                                    Other
                                                                    Diagnosis
                                                                    <p>
                                                                      Lights not
                                                                      working
                                                                    </p>
                                                                  </a>
                                                                </li>
                                                              </ul>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>
                                                                Randy Rocket
                                                                <span
                                                                  >60,000
                                                                  mi</span
                                                                >
                                                              </h3>
                                                            </div>
                                                            <div
                                                              class="nick-title"
                                                            >
                                                              <h3>Drop-Off</h3>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                            <div
                                                              class="
                                                                not-arrived
                                                              "
                                                            >
                                                              <div
                                                                class="arrived"
                                                              >
                                                                <h4>
                                                                  Not Arrived
                                                                  <img
                                                                    class="
                                                                      img-fluid
                                                                      ddg
                                                                    "
                                                                    src="assets/img/arrowd.svg"
                                                                    alt=""
                                                                  />
                                                                </h4>
                                                                <div
                                                                  class="
                                                                    arrived-con
                                                                  "
                                                                >
                                                                  <div
                                                                    class="
                                                                      ar-note
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Notes :
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        note-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                  <div
                                                                    class="
                                                                      ar-comp
                                                                    "
                                                                  >
                                                                    <p>
                                                                      <img
                                                                        class="
                                                                          img-fluid
                                                                        "
                                                                        src="assets/img/arrow-down.svg"
                                                                        alt=""
                                                                      />Completion
                                                                      :
                                                                      <span
                                                                        >06/18
                                                                        5:15
                                                                        PM</span
                                                                      >
                                                                    </p>
                                                                    <div
                                                                      class="
                                                                        comp-con
                                                                      "
                                                                    >
                                                                      <input
                                                                        type="email"
                                                                        class="
                                                                          form-control
                                                                        "
                                                                      />
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <!-- not-Arrived -->
                                                          </div>
                                                          <!-- metting-collap -->
                                                          <!-- meeting-footer -->
                                                          <div
                                                            class="
                                                              meeting-footer
                                                            "
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-mess.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cele.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a
                                                                  href="services-info.html"
                                                                  ><img
                                                                    src="assets/img/ser-user.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                              <li>
                                                                <a href="#"
                                                                  ><img
                                                                    src="assets/img/ser-cars.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <!-- meeting-footer -->
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!-- accordion-end -->
                                          </div>
                                        </div>
                                      </div>
                                      <!-- daytime-area -->
                                    </div>
                                    <!-- items -->
                                  </carousel>
                                </div>
                                <!-- slider -->
                              </div>
                              <div
                                class="tab-pane fade"
                                id="Advisor"
                                role="tabpanel"
                                aria-labelledby="Advisor-tab"
                              >
                                <!-- slider -->
                                <div class="sliders owl-carousel">
                                  <!-- items -->
                                  <div class="items">
                                    <!-- daytime-area -->
                                    <div class="daytime-area">
                                      <div class="title-time">
                                        <h4>Unassigned</h4>
                                        <a class="full-btn" href="#"
                                          >Full
                                          <!-- <img
                                            class="img-fluid"
                                            src="../../assets/img/arrow-d.svg"
                                            alt=""
                                        /> -->
                                        </a>
                                      </div>
                                      <div
                                        class="all-task simplebar"
                                        id="myElement18"
                                      >
                                        <div
                                          class="
                                            sortable
                                            connectedSortable
                                            ui-sortable
                                          "
                                        >
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample10"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        green-meeting
                                                      "
                                                      id="headingOne210"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne24"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne24"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/call-green.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne24"
                                                      class="collapse"
                                                      aria-labelledby="headingOne210"
                                                      data-parent="#accordionExample10"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample11"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        blue-meeting
                                                      "
                                                      id="headingOne25"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne25"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne25"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/blie-wl.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne25"
                                                      class="collapse"
                                                      aria-labelledby="headingOne25"
                                                      data-parent="#accordionExample11"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample12"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        red-meeting
                                                      "
                                                      id="headingOne26"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne26"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne26"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/red-h.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne26"
                                                      class="collapse"
                                                      aria-labelledby="headingOne26"
                                                      data-parent="#accordionExample12"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                        </div>
                                      </div>
                                    </div>
                                    <!-- daytime-area -->
                                  </div>
                                  <!-- items -->
                                  <!-- items -->
                                  <div class="items">
                                    <!-- daytime-area -->
                                    <div class="daytime-area">
                                      <div class="title-time">
                                        <h4>Poloski Hofman</h4>
                                        <a class="full-btn" href="#"
                                          >Full
                                          <img
                                            class="img-fluid"
                                            src="assets/img/arrow-d.svg"
                                            alt=""
                                        /></a>
                                      </div>
                                      <div
                                        class="all-task simplebar"
                                        id="myElement19"
                                      >
                                        <div
                                          class="
                                            sortable
                                            connectedSortable
                                            ui-sortable
                                          "
                                        >
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample13"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        green-meeting
                                                      "
                                                      id="headingOne27"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne27"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne27"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/call-green.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne27"
                                                      class="collapse"
                                                      aria-labelledby="headingOne27"
                                                      data-parent="#accordionExample13"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample14"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        blue-meeting
                                                      "
                                                      id="headingOne28"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne28"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne28"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/blie-wl.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne28"
                                                      class="collapse"
                                                      aria-labelledby="headingOne28"
                                                      data-parent="#accordionExample14"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample15"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        red-meeting
                                                      "
                                                      id="headingOne29"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne29"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne29"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/red-h.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne29"
                                                      class="collapse"
                                                      aria-labelledby="headingOne29"
                                                      data-parent="#accordionExample15"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                        </div>
                                      </div>
                                    </div>
                                    <!-- daytime-area -->
                                  </div>
                                  <!-- items -->
                                  <!-- items -->
                                  <div class="items">
                                    <!-- daytime-area -->
                                    <div class="daytime-area">
                                      <div class="title-time">
                                        <h4>Mahtab Uddin</h4>
                                        <a class="full-btn" href="#"
                                          >Full
                                          <img
                                            class="img-fluid"
                                            src="assets/img/arrow-d.svg"
                                            alt=""
                                        /></a>
                                      </div>
                                      <div
                                        class="all-task simplebar"
                                        id="myElement20"
                                      >
                                        <div
                                          class="
                                            sortable
                                            connectedSortable
                                            ui-sortable
                                          "
                                        >
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample16"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        green-meeting
                                                      "
                                                      id="headingOne30"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne30"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne30"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/call-green.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne30"
                                                      class="collapse"
                                                      aria-labelledby="headingOne30"
                                                      data-parent="#accordionExample16"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample17"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        blue-meeting
                                                      "
                                                      id="headingOne31"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne31"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne31"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/blie-wl.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne31"
                                                      class="collapse"
                                                      aria-labelledby="headingOne31"
                                                      data-parent="#accordionExample17"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                        </div>
                                      </div>
                                    </div>
                                    <!-- daytime-area -->
                                  </div>
                                  <!-- items -->
                                </div>
                                <!-- slider -->
                              </div>
                              <div
                                class="tab-pane fade"
                                id="Team"
                                role="tabpanel"
                                aria-labelledby="Team-tab"
                              >
                                <!-- slider -->
                                <div class="sliders owl-carousel">
                                  <!-- items -->
                                  <div class="items">
                                    <!-- daytime-area -->
                                    <div class="daytime-area">
                                      <div class="title-time">
                                        <h4>Team A</h4>
                                        <a class="full-btn" href="#"
                                          >Full
                                          <img
                                            class="img-fluid"
                                            src="assets/img/arrow-d.svg"
                                            alt=""
                                        /></a>
                                      </div>
                                      <div
                                        class="all-task simplebar"
                                        id="myElement21"
                                      >
                                        <div
                                          class="
                                            sortable
                                            connectedSortable
                                            ui-sortable
                                          "
                                        >
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample18"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        green-meeting
                                                      "
                                                      id="headingOne32"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne32"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne32"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/call-green.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne32"
                                                      class="collapse"
                                                      aria-labelledby="headingOne32"
                                                      data-parent="#accordionExample18"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample19"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        blue-meeting
                                                      "
                                                      id="headingOne33"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne33"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne33"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/blie-wl.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne33"
                                                      class="collapse"
                                                      aria-labelledby="headingOne33"
                                                      data-parent="#accordionExample19"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                        </div>
                                      </div>
                                    </div>
                                    <!-- daytime-area -->
                                  </div>
                                  <!-- items -->
                                  <!-- items -->
                                  <div class="items">
                                    <!-- daytime-area -->
                                    <div class="daytime-area">
                                      <div class="title-time">
                                        <h4>Team B</h4>
                                        <a class="full-btn" href="#"
                                          >Full
                                          <img
                                            class="img-fluid"
                                            src="assets/img/arrow-d.svg"
                                            alt=""
                                        /></a>
                                      </div>
                                      <div
                                        class="all-task simplebar"
                                        id="myElement22"
                                      >
                                        <div
                                          class="
                                            sortable
                                            connectedSortable
                                            ui-sortable
                                          "
                                        >
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample20"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        green-meeting
                                                      "
                                                      id="headingOne34"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne34"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne34"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/call-green.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne34"
                                                      class="collapse"
                                                      aria-labelledby="headingOne34"
                                                      data-parent="#accordionExample20"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample21"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        blue-meeting
                                                      "
                                                      id="headingOne351"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne351"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne351"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/blie-wl.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne351"
                                                      class="collapse"
                                                      aria-labelledby="headingOne351"
                                                      data-parent="#accordionExample21"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                        </div>
                                      </div>
                                    </div>
                                    <!-- daytime-area -->
                                  </div>
                                  <!-- items -->
                                  <!-- items -->
                                  <div class="items">
                                    <!-- daytime-area -->
                                    <div class="daytime-area">
                                      <div class="title-time">
                                        <h4>Team C</h4>
                                        <a class="full-btn" href="#"
                                          >Full
                                          <img
                                            class="img-fluid"
                                            src="assets/img/arrow-d.svg"
                                            alt=""
                                        /></a>
                                      </div>
                                      <div
                                        class="all-task simplebar"
                                        id="myElement23"
                                      >
                                        <div
                                          class="
                                            sortable
                                            connectedSortable
                                            ui-sortable
                                          "
                                        >
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample22"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        green-meeting
                                                      "
                                                      id="headingOne36"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne36"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne36"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/call-green.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne36"
                                                      class="collapse"
                                                      aria-labelledby="headingOne36"
                                                      data-parent="#accordionExample22"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample23"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        blue-meeting
                                                      "
                                                      id="headingOne37"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne37"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne37"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/blie-wl.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne37"
                                                      class="collapse"
                                                      aria-labelledby="headingOne37"
                                                      data-parent="#accordionExample23"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                        </div>
                                      </div>
                                    </div>
                                    <!-- daytime-area -->
                                  </div>
                                  <!-- items -->
                                </div>
                                <!-- slider -->
                              </div>
                              <div
                                class="tab-pane fade"
                                id="Status"
                                role="tabpanel"
                                aria-labelledby="Status-tab"
                              >
                                <!-- slider -->
                                <div class="sliders owl-carousel">
                                  <!-- items -->
                                  <div class="items">
                                    <!-- daytime-area -->
                                    <div class="daytime-area">
                                      <div class="title-time">
                                        <h4>Not Arrived</h4>
                                        <a class="full-btn" href="#"
                                          >Full
                                          <img
                                            class="img-fluid"
                                            src="assets/img/arrow-d.svg"
                                            alt=""
                                        /></a>
                                      </div>
                                      <div
                                        class="all-task simplebar"
                                        id="myElement24"
                                      >
                                        <div
                                          class="
                                            sortable
                                            connectedSortable
                                            ui-sortable
                                          "
                                        >
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample24"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        green-meeting
                                                      "
                                                      id="headingOne38"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne38"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne38"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/call-green.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne38"
                                                      class="collapse"
                                                      aria-labelledby="headingOne38"
                                                      data-parent="#accordionExample24"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample25"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        blue-meeting
                                                      "
                                                      id="headingOne39"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne39"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne39"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/blie-wl.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne39"
                                                      class="collapse"
                                                      aria-labelledby="headingOne39"
                                                      data-parent="#accordionExample25"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                        </div>
                                      </div>
                                    </div>
                                    <!-- daytime-area -->
                                  </div>
                                  <!-- items -->
                                  <!-- items -->
                                  <div class="items">
                                    <!-- daytime-area -->
                                    <div class="daytime-area">
                                      <div class="title-time">
                                        <h4>At Dealer</h4>
                                        <a class="full-btn" href="#"
                                          >Full
                                          <img
                                            class="img-fluid"
                                            src="assets/img/arrow-d.svg"
                                            alt=""
                                        /></a>
                                      </div>
                                      <div
                                        class="all-task simplebar"
                                        id="myElement25"
                                      >
                                        <div
                                          class="
                                            sortable
                                            connectedSortable
                                            ui-sortable
                                          "
                                        >
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample26"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        green-meeting
                                                      "
                                                      id="headingOne40"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne40"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne40"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/call-green.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne40"
                                                      class="collapse"
                                                      aria-labelledby="headingOne40"
                                                      data-parent="#accordionExample26"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample27"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        blue-meeting
                                                      "
                                                      id="headingOne41"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne41"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne41"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/blie-wl.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne41"
                                                      class="collapse"
                                                      aria-labelledby="headingOne41"
                                                      data-parent="#accordionExample27"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                        </div>
                                      </div>
                                    </div>
                                    <!-- daytime-area -->
                                  </div>
                                  <!-- items -->
                                  <!-- items -->
                                  <div class="items">
                                    <!-- daytime-area -->
                                    <div class="daytime-area">
                                      <div class="title-time">
                                        <h4>With Advisor</h4>
                                        <a class="full-btn" href="#"
                                          >Full
                                          <img
                                            class="img-fluid"
                                            src="assets/img/arrow-d.svg"
                                            alt=""
                                        /></a>
                                      </div>
                                      <div
                                        class="all-task simplebar"
                                        id="myElement26"
                                      >
                                        <div
                                          class="
                                            sortable
                                            connectedSortable
                                            ui-sortable
                                          "
                                        >
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample28"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        green-meeting
                                                      "
                                                      id="headingOne42"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne42"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne42"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/call-green.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne42"
                                                      class="collapse"
                                                      aria-labelledby="headingOne42"
                                                      data-parent="#accordionExample28"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                          <!-- accordion-start  -->
                                          <div class="">
                                            <div class="form-row">
                                              <div class="col-xl-2">
                                                <div class="datetime">
                                                  <p
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Drag Left Or Right"
                                                  >
                                                    9:00
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="col-xl-10">
                                                <div
                                                  class="accordion"
                                                  id="accordionExample29"
                                                >
                                                  <div class="card">
                                                    <div
                                                      class="
                                                        card-header
                                                        blue-meeting
                                                      "
                                                      id="headingOne43"
                                                    >
                                                      <h2 class="mb-0">
                                                        <button
                                                          class="
                                                            btn
                                                            btn-link
                                                            btn-block
                                                            text-left
                                                            collapsed
                                                          "
                                                          type="button"
                                                          data-toggle="collapse"
                                                          data-target="#collapseOne43"
                                                          aria-expanded="true"
                                                          aria-controls="collapseOne43"
                                                        >
                                                          2015 Hyundai Genesis
                                                          <p>Thomas Merlin</p>
                                                          <div
                                                            class="appo-menu"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a
                                                                  class="okay"
                                                                  href="#"
                                                                  ><img
                                                                    class="
                                                                      img-fluid
                                                                    "
                                                                    src="assets/img/blie-wl.svg"
                                                                    alt=""
                                                                /></a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </button>
                                                      </h2>
                                                    </div>
                                                    <div
                                                      id="collapseOne43"
                                                      class="collapse"
                                                      aria-labelledby="headingOne43"
                                                      data-parent="#accordionExample29"
                                                    >
                                                      <div class="card-body">
                                                        <!-- metting-collap -->
                                                        <div
                                                          class="metting-collap"
                                                        >
                                                          <div
                                                            class="contact-info"
                                                          >
                                                            <ul>
                                                              <li>
                                                                <a href="#">
                                                                  Contact
                                                                  <p>
                                                                    (876)
                                                                    231-2512
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Battery
                                                                  Service
                                                                  <p>
                                                                    Car won’t
                                                                    start when
                                                                    battery is
                                                                    dead
                                                                  </p>
                                                                </a>
                                                              </li>
                                                              <li>
                                                                <a href="#">
                                                                  Other
                                                                  Diagnosis
                                                                  <p>
                                                                    Lights not
                                                                    working
                                                                  </p>
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>
                                                              Randy Rocket
                                                              <span
                                                                >60,000 mi</span
                                                              >
                                                            </h3>
                                                          </div>
                                                          <div
                                                            class="nick-title"
                                                          >
                                                            <h3>Drop-Off</h3>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                          <div
                                                            class="not-arrived"
                                                          >
                                                            <div
                                                              class="arrived"
                                                            >
                                                              <h4>
                                                                Not Arrived
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                    ddg
                                                                  "
                                                                  src="assets/img/arrowd.svg"
                                                                  alt=""
                                                                />
                                                              </h4>
                                                              <div
                                                                class="
                                                                  arrived-con
                                                                "
                                                              >
                                                                <div
                                                                  class="
                                                                    ar-note
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Notes :
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      note-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  class="
                                                                    ar-comp
                                                                  "
                                                                >
                                                                  <p>
                                                                    <img
                                                                      class="
                                                                        img-fluid
                                                                      "
                                                                      src="assets/img/arrow-down.svg"
                                                                      alt=""
                                                                    />Completion
                                                                    :
                                                                    <span
                                                                      >06/18
                                                                      5:15
                                                                      PM</span
                                                                    >
                                                                  </p>
                                                                  <div
                                                                    class="
                                                                      comp-con
                                                                    "
                                                                  >
                                                                    <input
                                                                      type="email"
                                                                      class="
                                                                        form-control
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <!-- not-Arrived -->
                                                        </div>
                                                        <!-- metting-collap -->
                                                        <!-- meeting-footer -->
                                                        <div
                                                          class="meeting-footer"
                                                        >
                                                          <ul>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-mess.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cele.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="services-info.html"
                                                                ><img
                                                                  src="assets/img/ser-user.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                            <li>
                                                              <a href="#"
                                                                ><img
                                                                  src="assets/img/ser-cars.svg"
                                                                  alt=""
                                                              /></a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                        <!-- meeting-footer -->
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <!-- accordion-end -->
                                        </div>
                                      </div>
                                    </div>
                                    <!-- daytime-area -->
                                  </div>
                                  <!-- items -->
                                </div>
                                <!-- slider -->
                              </div>
                            </div>
                          </div>
                          <!--todaytime-tabs -->
                        </div>
                      </div>
                      <!-- week-right -->
                    </div>
                    <!-- today-tabs-end -->
                  </div>
                  <!-- Week tabs start -->
                  <div
                    class="tab-pane fade"
                    id="Week"
                    role="tabpanel"
                    aria-labelledby="Week-tab"
                  >
                    <!-- week-tabs-start -->
                    <div class="week-tabss">
                      <div class="row">
                        <div class="col-sm-6 col-md-4 col-lg-3 border-right">
                          <!-- Summary-tabs -->
                          <div class="samary-tabs">
                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                              <li class="nav-item" role="presentation">
                                <a
                                  class="nav-link active"
                                  id="Summary1-tab"
                                  data-toggle="tab"
                                  href="#Summary1"
                                  role="tab"
                                  aria-controls="Summary1"
                                  aria-selected="true"
                                  >Summary</a
                                >
                              </li>
                              <li class="nav-item" role="presentation">
                                <a
                                  class="nav-link"
                                  id="Capacity1-tab"
                                  data-toggle="tab"
                                  href="#Capacity1"
                                  role="tab"
                                  aria-controls="Capacity1"
                                  aria-selected="false"
                                  >Capacity</a
                                >
                              </li>
                              <li class="nav-item" role="presentation">
                                <a
                                  class="nav-link"
                                  id="Text1-tab"
                                  data-toggle="tab"
                                  href="#Text1"
                                  role="tab"
                                  aria-controls="Text1"
                                  aria-selected="false"
                                  >Text</a
                                >
                              </li>
                            </ul>
                            <div class="tab-content" id="myTabContent">
                              <div
                                class="tab-pane fade show active"
                                id="Summary1"
                                role="tabpanel"
                                aria-labelledby="Summary1-tab"
                              >
                                <!-- summary-table   -->
                                <div class="sammary-table">
                                  <table class="table">
                                    <thead>
                                      <tr>
                                        <th>Workdays</th>
                                        <th>View</th>
                                        <th>All</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>Monday</td>
                                        <td>0</td>
                                        <td>0</td>
                                      </tr>
                                      <tr>
                                        <td>Tuesday</td>
                                        <td>0</td>
                                        <td>0</td>
                                      </tr>
                                      <tr>
                                        <td>Wednesday</td>
                                        <td>0</td>
                                        <td>0</td>
                                      </tr>
                                      <tr>
                                        <td>Thursday</td>
                                        <td>0</td>
                                        <td>0</td>
                                      </tr>
                                      <tr>
                                        <td>Friday</td>
                                        <td>0</td>
                                        <td>0</td>
                                      </tr>
                                      <tr>
                                        <td>Saturday</td>
                                        <td>0</td>
                                        <td>0</td>
                                      </tr>
                                      <tr>
                                        <td>Sunday</td>
                                        <td>0</td>
                                        <td>0</td>
                                      </tr>
                                      <tr>
                                        <td>Totals</td>
                                        <td>0</td>
                                        <td>0</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <!-- summary-table   -->
                              </div>
                              <div
                                class="tab-pane fade"
                                id="Capacity1"
                                role="tabpanel"
                                aria-labelledby="Capacity1-tab"
                              ></div>
                              <div
                                class="tab-pane fade"
                                id="Text1"
                                role="tabpanel"
                                aria-labelledby="Text1-tab"
                              ></div>
                            </div>
                          </div>
                          <!-- Summary-tabs -->
                        </div>
                        <!-- right -->
                        <div class="col-sm-6 col-md-8 col-lg-9">
                          <div class="weekes-right">
                            <!-- titmeline-filter -->
                            <div class="titmeline-filter">
                              <div class="timeline">
                                <button type="button" class="current">
                                  <span class="today">Today</span>
                                </button>
                                <button type="button">
                                  <span class="today">This month</span>
                                </button>
                                <button type="button">
                                  <input
                                    type="text"
                                    name="datefilter"
                                    value=""
                                  />
                                  <span class="month">Custom day</span>
                                </button>
                                <button type="button" class="add-appi">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="8"
                                    viewBox="0 0 12 8"
                                    fill="none"
                                  >
                                    <path
                                      d="M4.66667 8H7.33333V6.66667H4.66667V8ZM0 0V1.33333H12V0H0ZM2 4.66667H10V3.33333H2V4.66667Z"
                                      fill="#3151A1"
                                    />
                                  </svg>
                                  <span class="month">Filter</span>
                                </button>
                              </div>
                            </div>
                            <!-- titmeline-filter -->
                            <!-- slider -->
                            <div class="sliders owl-carousel">
                              <!-- items -->
                              <div class="items">
                                <!-- daytime-area -->
                                <div class="daytime-area">
                                  <div class="title-time">
                                    <h4>Tuesday</h4>
                                    <a class="full-btn" href="#"
                                      >Full
                                      <img
                                        class="img-fluid"
                                        src="assets/img/arrow-d.svg"
                                        alt=""
                                    /></a>
                                  </div>
                                  <div
                                    class="all-task simplebar"
                                    id="myElement27"
                                  >
                                    <div
                                      class="
                                        sortable
                                        connectedSortable
                                        ui-sortable
                                      "
                                    >
                                      <!-- accordion-start  -->
                                      <div
                                        class="
                                          ui-state-default ui-sortable-handle
                                        "
                                      >
                                        <div class="form-row">
                                          <div class="col-xl-2">
                                            <div class="datetime">
                                              <p
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title="Drag Left Or Right"
                                              >
                                                9:00
                                              </p>
                                            </div>
                                          </div>
                                          <div class="col-xl-10">
                                            <div
                                              class="accordion"
                                              id="accordionExample30"
                                            >
                                              <div class="card">
                                                <div
                                                  class="
                                                    card-header
                                                    green-meeting
                                                  "
                                                  id="headingOne44"
                                                >
                                                  <h2 class="mb-0">
                                                    <button
                                                      class="
                                                        btn btn-link btn-block
                                                        text-left
                                                        collapsed
                                                      "
                                                      type="button"
                                                      data-toggle="collapse"
                                                      data-target="#collapseOne44"
                                                      aria-expanded="true"
                                                      aria-controls="collapseOne44"
                                                    >
                                                      2015 Hyundai Genesis
                                                      <p>Thomas Merlin</p>
                                                      <div class="appo-menu">
                                                        <ul>
                                                          <li>
                                                            <a
                                                              class="okay"
                                                              href="#"
                                                              ><img
                                                                class="
                                                                  img-fluid
                                                                "
                                                                src="assets/img/call-green.svg"
                                                                alt=""
                                                            /></a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </button>
                                                  </h2>
                                                </div>
                                                <div
                                                  id="collapseOne44"
                                                  class="collapse"
                                                  aria-labelledby="headingOne44"
                                                  data-parent="#accordionExample30"
                                                >
                                                  <div class="card-body">
                                                    <!-- metting-collap -->
                                                    <div class="metting-collap">
                                                      <div class="contact-info">
                                                        <ul>
                                                          <li>
                                                            <a href="#">
                                                              Contact
                                                              <p>
                                                                (876) 231-2512
                                                              </p>
                                                            </a>
                                                          </li>
                                                          <li>
                                                            <a href="#">
                                                              Battery Service
                                                              <p>
                                                                Car won’t start
                                                                when battery is
                                                                dead
                                                              </p>
                                                            </a>
                                                          </li>
                                                          <li>
                                                            <a href="#">
                                                              Other Diagnosis
                                                              <p>
                                                                Lights not
                                                                working
                                                              </p>
                                                            </a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                      <div class="nick-title">
                                                        <h3>
                                                          Randy Rocket
                                                          <span>60,000 mi</span>
                                                        </h3>
                                                      </div>
                                                      <div class="nick-title">
                                                        <h3>Drop-Off</h3>
                                                      </div>
                                                      <!-- not-Arrived -->
                                                      <div class="not-arrived">
                                                        <div class="arrived">
                                                          <h4>
                                                            Not Arrived
                                                            <img
                                                              class="
                                                                img-fluid
                                                                ddg
                                                              "
                                                              src="assets/img/arrowd.svg"
                                                              alt=""
                                                            />
                                                          </h4>
                                                          <div
                                                            class="arrived-con"
                                                          >
                                                            <div
                                                              class="ar-note"
                                                            >
                                                              <p>
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                  "
                                                                  src="assets/img/arrow-down.svg"
                                                                  alt=""
                                                                />Notes :
                                                              </p>
                                                              <div
                                                                class="note-con"
                                                              >
                                                                <input
                                                                  type="email"
                                                                  class="
                                                                    form-control
                                                                  "
                                                                />
                                                              </div>
                                                            </div>
                                                            <div
                                                              class="ar-comp"
                                                            >
                                                              <p>
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                  "
                                                                  src="assets/img/arrow-down.svg"
                                                                  alt=""
                                                                />Completion :
                                                                <span
                                                                  >06/18 5:15
                                                                  PM</span
                                                                >
                                                              </p>
                                                              <div
                                                                class="comp-con"
                                                              >
                                                                <input
                                                                  type="email"
                                                                  class="
                                                                    form-control
                                                                  "
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <!-- not-Arrived -->
                                                    </div>
                                                    <!-- metting-collap -->
                                                    <!-- meeting-footer -->
                                                    <div class="meeting-footer">
                                                      <ul>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-mess.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-cele.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a
                                                            href="services-info.html"
                                                            ><img
                                                              src="assets/img/ser-user.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-cars.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                    <!-- meeting-footer -->
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <!-- accordion-end -->
                                      <!-- accordion-start  -->
                                      <div
                                        class="
                                          ui-state-default ui-sortable-handle
                                        "
                                      >
                                        <div class="form-row">
                                          <div class="col-xl-2">
                                            <div class="datetime">
                                              <p
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title="Drag Left Or Right"
                                              >
                                                9:00
                                              </p>
                                            </div>
                                          </div>
                                          <div class="col-xl-10">
                                            <div
                                              class="accordion"
                                              id="accordionExample31"
                                            >
                                              <div class="card">
                                                <div
                                                  class="
                                                    card-header
                                                    blue-meeting
                                                  "
                                                  id="headingOne45"
                                                >
                                                  <h2 class="mb-0">
                                                    <button
                                                      class="
                                                        btn btn-link btn-block
                                                        text-left
                                                        collapsed
                                                      "
                                                      type="button"
                                                      data-toggle="collapse"
                                                      data-target="#collapseOne45"
                                                      aria-expanded="true"
                                                      aria-controls="collapseOne45"
                                                    >
                                                      2015 Hyundai Genesis
                                                      <p>Thomas Merlin</p>
                                                      <div class="appo-menu">
                                                        <ul>
                                                          <li>
                                                            <a
                                                              class="okay"
                                                              href="#"
                                                              ><img
                                                                class="
                                                                  img-fluid
                                                                "
                                                                src="assets/img/blie-wl.svg"
                                                                alt=""
                                                            /></a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </button>
                                                  </h2>
                                                </div>
                                                <div
                                                  id="collapseOne45"
                                                  class="collapse"
                                                  aria-labelledby="headingOne45"
                                                  data-parent="#accordionExample31"
                                                >
                                                  <div class="card-body">
                                                    <!-- metting-collap -->
                                                    <div class="metting-collap">
                                                      <div class="contact-info">
                                                        <ul>
                                                          <li>
                                                            <a href="#">
                                                              Contact
                                                              <p>
                                                                (876) 231-2512
                                                              </p>
                                                            </a>
                                                          </li>
                                                          <li>
                                                            <a href="#">
                                                              Battery Service
                                                              <p>
                                                                Car won’t start
                                                                when battery is
                                                                dead
                                                              </p>
                                                            </a>
                                                          </li>
                                                          <li>
                                                            <a href="#">
                                                              Other Diagnosis
                                                              <p>
                                                                Lights not
                                                                working
                                                              </p>
                                                            </a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                      <div class="nick-title">
                                                        <h3>
                                                          Randy Rocket
                                                          <span>60,000 mi</span>
                                                        </h3>
                                                      </div>
                                                      <div class="nick-title">
                                                        <h3>Drop-Off</h3>
                                                      </div>
                                                      <!-- not-Arrived -->
                                                      <div class="not-arrived">
                                                        <div class="arrived">
                                                          <h4>
                                                            Not Arrived
                                                            <img
                                                              class="
                                                                img-fluid
                                                                ddg
                                                              "
                                                              src="assets/img/arrowd.svg"
                                                              alt=""
                                                            />
                                                          </h4>
                                                          <div
                                                            class="arrived-con"
                                                          >
                                                            <div
                                                              class="ar-note"
                                                            >
                                                              <p>
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                  "
                                                                  src="assets/img/arrow-down.svg"
                                                                  alt=""
                                                                />Notes :
                                                              </p>
                                                              <div
                                                                class="note-con"
                                                              >
                                                                <input
                                                                  type="email"
                                                                  class="
                                                                    form-control
                                                                  "
                                                                />
                                                              </div>
                                                            </div>
                                                            <div
                                                              class="ar-comp"
                                                            >
                                                              <p>
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                  "
                                                                  src="assets/img/arrow-down.svg"
                                                                  alt=""
                                                                />Completion :
                                                                <span
                                                                  >06/18 5:15
                                                                  PM</span
                                                                >
                                                              </p>
                                                              <div
                                                                class="comp-con"
                                                              >
                                                                <input
                                                                  type="email"
                                                                  class="
                                                                    form-control
                                                                  "
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <!-- not-Arrived -->
                                                    </div>
                                                    <!-- metting-collap -->
                                                    <!-- meeting-footer -->
                                                    <div class="meeting-footer">
                                                      <ul>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-mess.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-cele.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a
                                                            href="services-info.html"
                                                            ><img
                                                              src="assets/img/ser-user.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-cars.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                    <!-- meeting-footer -->
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <!-- accordion-end -->
                                    </div>
                                  </div>
                                </div>
                                <!-- daytime-area -->
                              </div>
                              <!-- items -->
                              <!-- items -->
                              <div class="items">
                                <!-- daytime-area -->
                                <div class="daytime-area">
                                  <div class="title-time">
                                    <h4>Wednesday</h4>
                                    <a class="full-btn" href="#"
                                      >Full
                                      <img
                                        class="img-fluid"
                                        src="assets/img/arrow-d.svg"
                                        alt=""
                                    /></a>
                                  </div>
                                  <div
                                    class="all-task simplebar"
                                    id="myElement28"
                                  >
                                    <div
                                      class="
                                        sortable
                                        connectedSortable
                                        ui-sortable
                                      "
                                    >
                                      <!-- accordion-start  -->
                                      <div
                                        class="
                                          ui-state-default ui-sortable-handle
                                        "
                                      >
                                        <div class="form-row">
                                          <div class="col-xl-2">
                                            <div class="datetime">
                                              <p
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title="Drag Left Or Right"
                                              >
                                                9:00
                                              </p>
                                            </div>
                                          </div>
                                          <div class="col-xl-10">
                                            <div
                                              class="accordion"
                                              id="accordionExample32"
                                            >
                                              <div class="card">
                                                <div
                                                  class="
                                                    card-header
                                                    green-meeting
                                                  "
                                                  id="headingOne46"
                                                >
                                                  <h2 class="mb-0">
                                                    <button
                                                      class="
                                                        btn btn-link btn-block
                                                        text-left
                                                        collapsed
                                                      "
                                                      type="button"
                                                      data-toggle="collapse"
                                                      data-target="#collapseOne46"
                                                      aria-expanded="true"
                                                      aria-controls="collapseOne46"
                                                    >
                                                      2015 Hyundai Genesis
                                                      <p>Thomas Merlin</p>
                                                      <div class="appo-menu">
                                                        <ul>
                                                          <li>
                                                            <a
                                                              class="okay"
                                                              href="#"
                                                              ><img
                                                                class="
                                                                  img-fluid
                                                                "
                                                                src="assets/img/call-green.svg"
                                                                alt=""
                                                            /></a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </button>
                                                  </h2>
                                                </div>
                                                <div
                                                  id="collapseOne46"
                                                  class="collapse"
                                                  aria-labelledby="headingOne46"
                                                  data-parent="#accordionExample32"
                                                >
                                                  <div class="card-body">
                                                    <!-- metting-collap -->
                                                    <div class="metting-collap">
                                                      <div class="contact-info">
                                                        <ul>
                                                          <li>
                                                            <a href="#">
                                                              Contact
                                                              <p>
                                                                (876) 231-2512
                                                              </p>
                                                            </a>
                                                          </li>
                                                          <li>
                                                            <a href="#">
                                                              Battery Service
                                                              <p>
                                                                Car won’t start
                                                                when battery is
                                                                dead
                                                              </p>
                                                            </a>
                                                          </li>
                                                          <li>
                                                            <a href="#">
                                                              Other Diagnosis
                                                              <p>
                                                                Lights not
                                                                working
                                                              </p>
                                                            </a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                      <div class="nick-title">
                                                        <h3>
                                                          Randy Rocket
                                                          <span>60,000 mi</span>
                                                        </h3>
                                                      </div>
                                                      <div class="nick-title">
                                                        <h3>Drop-Off</h3>
                                                      </div>
                                                      <!-- not-Arrived -->
                                                      <div class="not-arrived">
                                                        <div class="arrived">
                                                          <h4>
                                                            Not Arrived
                                                            <img
                                                              class="
                                                                img-fluid
                                                                ddg
                                                              "
                                                              src="assets/img/arrowd.svg"
                                                              alt=""
                                                            />
                                                          </h4>
                                                          <div
                                                            class="arrived-con"
                                                          >
                                                            <div
                                                              class="ar-note"
                                                            >
                                                              <p>
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                  "
                                                                  src="assets/img/arrow-down.svg"
                                                                  alt=""
                                                                />Notes :
                                                              </p>
                                                              <div
                                                                class="note-con"
                                                              >
                                                                <input
                                                                  type="email"
                                                                  class="
                                                                    form-control
                                                                  "
                                                                />
                                                              </div>
                                                            </div>
                                                            <div
                                                              class="ar-comp"
                                                            >
                                                              <p>
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                  "
                                                                  src="assets/img/arrow-down.svg"
                                                                  alt=""
                                                                />Completion :
                                                                <span
                                                                  >06/18 5:15
                                                                  PM</span
                                                                >
                                                              </p>
                                                              <div
                                                                class="comp-con"
                                                              >
                                                                <input
                                                                  type="email"
                                                                  class="
                                                                    form-control
                                                                  "
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <!-- not-Arrived -->
                                                    </div>
                                                    <!-- metting-collap -->
                                                    <!-- meeting-footer -->
                                                    <div class="meeting-footer">
                                                      <ul>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-mess.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-cele.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a
                                                            href="services-info.html"
                                                            ><img
                                                              src="assets/img/ser-user.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-cars.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                    <!-- meeting-footer -->
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <!-- accordion-end -->
                                      <!-- accordion-start  -->
                                      <div
                                        class="
                                          ui-state-default ui-sortable-handle
                                        "
                                      >
                                        <div class="form-row">
                                          <div class="col-xl-2">
                                            <div class="datetime">
                                              <p
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title="Drag Left Or Right"
                                              >
                                                9:00
                                              </p>
                                            </div>
                                          </div>
                                          <div class="col-xl-10">
                                            <div
                                              class="accordion"
                                              id="accordionExample33"
                                            >
                                              <div class="card">
                                                <div
                                                  class="
                                                    card-header
                                                    blue-meeting
                                                  "
                                                  id="headingOne47"
                                                >
                                                  <h2 class="mb-0">
                                                    <button
                                                      class="
                                                        btn btn-link btn-block
                                                        text-left
                                                        collapsed
                                                      "
                                                      type="button"
                                                      data-toggle="collapse"
                                                      data-target="#collapseOne47"
                                                      aria-expanded="true"
                                                      aria-controls="collapseOne47"
                                                    >
                                                      2015 Hyundai Genesis
                                                      <p>Thomas Merlin</p>
                                                      <div class="appo-menu">
                                                        <ul>
                                                          <li>
                                                            <a
                                                              class="okay"
                                                              href="#"
                                                              ><img
                                                                class="
                                                                  img-fluid
                                                                "
                                                                src="assets/img/blie-wl.svg"
                                                                alt=""
                                                            /></a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </button>
                                                  </h2>
                                                </div>
                                                <div
                                                  id="collapseOne47"
                                                  class="collapse"
                                                  aria-labelledby="headingOne47"
                                                  data-parent="#accordionExample33"
                                                >
                                                  <div class="card-body">
                                                    <!-- metting-collap -->
                                                    <div class="metting-collap">
                                                      <div class="contact-info">
                                                        <ul>
                                                          <li>
                                                            <a href="#">
                                                              Contact
                                                              <p>
                                                                (876) 231-2512
                                                              </p>
                                                            </a>
                                                          </li>
                                                          <li>
                                                            <a href="#">
                                                              Battery Service
                                                              <p>
                                                                Car won’t start
                                                                when battery is
                                                                dead
                                                              </p>
                                                            </a>
                                                          </li>
                                                          <li>
                                                            <a href="#">
                                                              Other Diagnosis
                                                              <p>
                                                                Lights not
                                                                working
                                                              </p>
                                                            </a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                      <div class="nick-title">
                                                        <h3>
                                                          Randy Rocket
                                                          <span>60,000 mi</span>
                                                        </h3>
                                                      </div>
                                                      <div class="nick-title">
                                                        <h3>Drop-Off</h3>
                                                      </div>
                                                      <!-- not-Arrived -->
                                                      <div class="not-arrived">
                                                        <div class="arrived">
                                                          <h4>
                                                            Not Arrived
                                                            <img
                                                              class="
                                                                img-fluid
                                                                ddg
                                                              "
                                                              src="assets/img/arrowd.svg"
                                                              alt=""
                                                            />
                                                          </h4>
                                                          <div
                                                            class="arrived-con"
                                                          >
                                                            <div
                                                              class="ar-note"
                                                            >
                                                              <p>
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                  "
                                                                  src="assets/img/arrow-down.svg"
                                                                  alt=""
                                                                />Notes :
                                                              </p>
                                                              <div
                                                                class="note-con"
                                                              >
                                                                <input
                                                                  type="email"
                                                                  class="
                                                                    form-control
                                                                  "
                                                                />
                                                              </div>
                                                            </div>
                                                            <div
                                                              class="ar-comp"
                                                            >
                                                              <p>
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                  "
                                                                  src="assets/img/arrow-down.svg"
                                                                  alt=""
                                                                />Completion :
                                                                <span
                                                                  >06/18 5:15
                                                                  PM</span
                                                                >
                                                              </p>
                                                              <div
                                                                class="comp-con"
                                                              >
                                                                <input
                                                                  type="email"
                                                                  class="
                                                                    form-control
                                                                  "
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <!-- not-Arrived -->
                                                    </div>
                                                    <!-- metting-collap -->
                                                    <!-- meeting-footer -->
                                                    <div class="meeting-footer">
                                                      <ul>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-mess.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-cele.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a
                                                            href="services-info.html"
                                                            ><img
                                                              src="assets/img/ser-user.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-cars.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                    <!-- meeting-footer -->
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <!-- accordion-end -->
                                    </div>
                                  </div>
                                </div>
                                <!-- daytime-area -->
                              </div>
                              <!-- items -->
                              <!-- items -->
                              <div class="items">
                                <!-- daytime-area -->
                                <div class="daytime-area">
                                  <div class="title-time">
                                    <h4>Thursday</h4>
                                    <a class="full-btn" href="#"
                                      >Full
                                      <img
                                        class="img-fluid"
                                        src="assets/img/arrow-d.svg"
                                        alt=""
                                    /></a>
                                  </div>
                                  <div
                                    class="all-task simplebar"
                                    id="myElement29"
                                  >
                                    <div
                                      class="
                                        sortable
                                        connectedSortable
                                        ui-sortable
                                      "
                                    >
                                      <!-- accordion-start  -->
                                      <div
                                        class="
                                          ui-state-default ui-sortable-handle
                                        "
                                      >
                                        <div class="form-row">
                                          <div class="col-xl-2">
                                            <div class="datetime">
                                              <p
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title="Drag Left Or Right"
                                              >
                                                9:00
                                              </p>
                                            </div>
                                          </div>
                                          <div class="col-xl-10">
                                            <div
                                              class="accordion"
                                              id="accordionExample34"
                                            >
                                              <div class="card">
                                                <div
                                                  class="
                                                    card-header
                                                    green-meeting
                                                  "
                                                  id="headingOne48"
                                                >
                                                  <h2 class="mb-0">
                                                    <button
                                                      class="
                                                        btn btn-link btn-block
                                                        text-left
                                                        collapsed
                                                      "
                                                      type="button"
                                                      data-toggle="collapse"
                                                      data-target="#collapseOne48"
                                                      aria-expanded="true"
                                                      aria-controls="collapseOne48"
                                                    >
                                                      2015 Hyundai Genesis
                                                      <p>Thomas Merlin</p>
                                                      <div class="appo-menu">
                                                        <ul>
                                                          <li>
                                                            <a
                                                              class="okay"
                                                              href="#"
                                                              ><img
                                                                class="
                                                                  img-fluid
                                                                "
                                                                src="assets/img/call-green.svg"
                                                                alt=""
                                                            /></a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </button>
                                                  </h2>
                                                </div>
                                                <div
                                                  id="collapseOne48"
                                                  class="collapse"
                                                  aria-labelledby="headingOne48"
                                                  data-parent="#accordionExample34"
                                                >
                                                  <div class="card-body">
                                                    <!-- metting-collap -->
                                                    <div class="metting-collap">
                                                      <div class="contact-info">
                                                        <ul>
                                                          <li>
                                                            <a href="#">
                                                              Contact
                                                              <p>
                                                                (876) 231-2512
                                                              </p>
                                                            </a>
                                                          </li>
                                                          <li>
                                                            <a href="#">
                                                              Battery Service
                                                              <p>
                                                                Car won’t start
                                                                when battery is
                                                                dead
                                                              </p>
                                                            </a>
                                                          </li>
                                                          <li>
                                                            <a href="#">
                                                              Other Diagnosis
                                                              <p>
                                                                Lights not
                                                                working
                                                              </p>
                                                            </a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                      <div class="nick-title">
                                                        <h3>
                                                          Randy Rocket
                                                          <span>60,000 mi</span>
                                                        </h3>
                                                      </div>
                                                      <div class="nick-title">
                                                        <h3>Drop-Off</h3>
                                                      </div>
                                                      <!-- not-Arrived -->
                                                      <div class="not-arrived">
                                                        <div class="arrived">
                                                          <h4>
                                                            Not Arrived
                                                            <img
                                                              class="
                                                                img-fluid
                                                                ddg
                                                              "
                                                              src="assets/img/arrowd.svg"
                                                              alt=""
                                                            />
                                                          </h4>
                                                          <div
                                                            class="arrived-con"
                                                          >
                                                            <div
                                                              class="ar-note"
                                                            >
                                                              <p>
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                  "
                                                                  src="assets/img/arrow-down.svg"
                                                                  alt=""
                                                                />Notes :
                                                              </p>
                                                              <div
                                                                class="note-con"
                                                              >
                                                                <input
                                                                  type="email"
                                                                  class="
                                                                    form-control
                                                                  "
                                                                />
                                                              </div>
                                                            </div>
                                                            <div
                                                              class="ar-comp"
                                                            >
                                                              <p>
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                  "
                                                                  src="assets/img/arrow-down.svg"
                                                                  alt=""
                                                                />Completion :
                                                                <span
                                                                  >06/18 5:15
                                                                  PM</span
                                                                >
                                                              </p>
                                                              <div
                                                                class="comp-con"
                                                              >
                                                                <input
                                                                  type="email"
                                                                  class="
                                                                    form-control
                                                                  "
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <!-- not-Arrived -->
                                                    </div>
                                                    <!-- metting-collap -->
                                                    <!-- meeting-footer -->
                                                    <div class="meeting-footer">
                                                      <ul>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-mess.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-cele.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a
                                                            href="services-info.html"
                                                            ><img
                                                              src="assets/img/ser-user.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-cars.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                    <!-- meeting-footer -->
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <!-- accordion-end -->
                                      <!-- accordion-start  -->
                                      <div
                                        class="
                                          ui-state-default ui-sortable-handle
                                        "
                                      >
                                        <div class="form-row">
                                          <div class="col-xl-2">
                                            <div class="datetime">
                                              <p
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title="Drag Left Or Right"
                                              >
                                                9:00
                                              </p>
                                            </div>
                                          </div>
                                          <div class="col-xl-10">
                                            <div
                                              class="accordion"
                                              id="accordionExample35"
                                            >
                                              <div class="card">
                                                <div
                                                  class="
                                                    card-header
                                                    blue-meeting
                                                  "
                                                  id="headingOne49"
                                                >
                                                  <h2 class="mb-0">
                                                    <button
                                                      class="
                                                        btn btn-link btn-block
                                                        text-left
                                                        collapsed
                                                      "
                                                      type="button"
                                                      data-toggle="collapse"
                                                      data-target="#collapseOne49"
                                                      aria-expanded="true"
                                                      aria-controls="collapseOne49"
                                                    >
                                                      2015 Hyundai Genesis
                                                      <p>Thomas Merlin</p>
                                                      <div class="appo-menu">
                                                        <ul>
                                                          <li>
                                                            <a
                                                              class="okay"
                                                              href="#"
                                                              ><img
                                                                class="
                                                                  img-fluid
                                                                "
                                                                src="assets/img/blie-wl.svg"
                                                                alt=""
                                                            /></a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </button>
                                                  </h2>
                                                </div>
                                                <div
                                                  id="collapseOne49"
                                                  class="collapse"
                                                  aria-labelledby="headingOne49"
                                                  data-parent="#accordionExample35"
                                                >
                                                  <div class="card-body">
                                                    <!-- metting-collap -->
                                                    <div class="metting-collap">
                                                      <div class="contact-info">
                                                        <ul>
                                                          <li>
                                                            <a href="#">
                                                              Contact
                                                              <p>
                                                                (876) 231-2512
                                                              </p>
                                                            </a>
                                                          </li>
                                                          <li>
                                                            <a href="#">
                                                              Battery Service
                                                              <p>
                                                                Car won’t start
                                                                when battery is
                                                                dead
                                                              </p>
                                                            </a>
                                                          </li>
                                                          <li>
                                                            <a href="#">
                                                              Other Diagnosis
                                                              <p>
                                                                Lights not
                                                                working
                                                              </p>
                                                            </a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                      <div class="nick-title">
                                                        <h3>
                                                          Randy Rocket
                                                          <span>60,000 mi</span>
                                                        </h3>
                                                      </div>
                                                      <div class="nick-title">
                                                        <h3>Drop-Off</h3>
                                                      </div>
                                                      <!-- not-Arrived -->
                                                      <div class="not-arrived">
                                                        <div class="arrived">
                                                          <h4>
                                                            Not Arrived
                                                            <img
                                                              class="
                                                                img-fluid
                                                                ddg
                                                              "
                                                              src="assets/img/arrowd.svg"
                                                              alt=""
                                                            />
                                                          </h4>
                                                          <div
                                                            class="arrived-con"
                                                          >
                                                            <div
                                                              class="ar-note"
                                                            >
                                                              <p>
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                  "
                                                                  src="assets/img/arrow-down.svg"
                                                                  alt=""
                                                                />Notes :
                                                              </p>
                                                              <div
                                                                class="note-con"
                                                              >
                                                                <input
                                                                  type="email"
                                                                  class="
                                                                    form-control
                                                                  "
                                                                />
                                                              </div>
                                                            </div>
                                                            <div
                                                              class="ar-comp"
                                                            >
                                                              <p>
                                                                <img
                                                                  class="
                                                                    img-fluid
                                                                  "
                                                                  src="assets/img/arrow-down.svg"
                                                                  alt=""
                                                                />Completion :
                                                                <span
                                                                  >06/18 5:15
                                                                  PM</span
                                                                >
                                                              </p>
                                                              <div
                                                                class="comp-con"
                                                              >
                                                                <input
                                                                  type="email"
                                                                  class="
                                                                    form-control
                                                                  "
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <!-- not-Arrived -->
                                                    </div>
                                                    <!-- metting-collap -->
                                                    <!-- meeting-footer -->
                                                    <div class="meeting-footer">
                                                      <ul>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-mess.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-cele.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a
                                                            href="services-info.html"
                                                            ><img
                                                              src="assets/img/ser-user.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                        <li>
                                                          <a href="#"
                                                            ><img
                                                              src="assets/img/ser-cars.svg"
                                                              alt=""
                                                          /></a>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                    <!-- meeting-footer -->
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <!-- accordion-end -->
                                    </div>
                                  </div>
                                </div>
                                <!-- daytime-area -->
                              </div>
                              <!-- items -->
                            </div>
                            <!-- slider -->
                          </div>
                        </div>
                        <!-- right -->
                      </div>
                    </div>
                  </div>
                  <!-- Week tabs end -->
                  <!-- Month tabs start -->
                  <div
                    class="tab-pane fade"
                    id="Month"
                    role="tabpanel"
                    aria-labelledby="Month-tab"
                  >
                    <!-- monnt-start -->
                    <div class="months-tabs">
                      <div class="total-ros">
                        <ul>
                          <li>
                            <a href="#">
                              Total Appt. :
                              <p>20</p>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              Total ROS :
                              <p>20</p>
                            </a>
                          </li>
                          <li>
                            <a href="#">Total RO : <span>$0.00</span></a>
                          </li>
                          <li>
                            <a href="#">Avg RO : <span>$0.00</span></a>
                          </li>
                        </ul>
                      </div>
                      <!-- titmeline-filter -->
                      <div class="titmeline-filter">
                        <div class="timeline">
                          <button type="button" class="current">
                            <span class="today">Today</span>
                          </button>
                          <button type="button">
                            <span class="today">This month</span>
                          </button>
                          <button type="button">
                            <input type="text" name="datefilter" value="" />
                            <span class="month">Custom day</span>
                          </button>
                        </div>
                      </div>
                      <!-- titmeline-filter -->
                      <div class="graph-boxhome">
                        <div id="serviceschat2">
                                  <apexchart
                                  v-if="chart"
                                  type="bar"
                                  height="350"
                                  :options="chartOptions"
                                  :series="series"
                                ></apexchart>
                        </div>
                      </div>
                      <!-- monthy-view -->
                      <div class="month-all">
                        <div class="monthy-views">
                          <h5>Total Appointments</h5>
                          <div class="monthy">
                            <div id="serviceschat3">
                               <apexchart v-if="chart" type="donut" :options="donutchartOptions" :series="donutseries"></apexchart>
                            </div>
                          </div>
                          <div class="avg-view">
                            <ul>
                              <li>
                                <span class="th"></span> 224
                                <p>This Month</p>
                              </li>
                              <li>
                                <span class="la"></span> 96
                                <p>Last Month</p>
                              </li>
                              <li>
                                15
                                <p>Avg MTD</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="monthy-views">
                          <h5>No Show</h5>
                          <div class="monthy">
                            <div id="serviceschat4">
                               <apexchart v-if="chart" type="donut" :options="donutchartOptions" :series="donutseries"></apexchart>
                            </div>
                          </div>
                          <div class="avg-view">
                            <ul>
                              <li>
                                <span class="th"></span> 224
                                <p>This Month</p>
                              </li>
                              <li>
                                <span class="la"></span> 96
                                <p>Last Month</p>
                              </li>
                              <li>
                                15
                                <p>Avg MTD</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="monthy-views">
                          <h5>Promotions</h5>
                          <div class="monthy">
                            <div id="serviceschat5">
                               <apexchart v-if="chart" type="donut" :options="donutchartOptions" :series="donutseries"></apexchart>
                            </div>
                          </div>
                          <div class="avg-view">
                            <ul>
                              <li>
                                <span class="th"></span> 224
                                <p>This Month</p>
                              </li>
                              <li>
                                <span class="la"></span> 96
                                <p>Last Month</p>
                              </li>
                              <li>
                                15
                                <p>Avg MTD</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="monthy-views">
                          <h5>Loaners</h5>
                          <div class="monthy">
                            <div id="serviceschat6">
                               <apexchart v-if="chart" type="donut" :options="donutchartOptions" :series="donutseries"></apexchart>
                            </div>
                          </div>
                          <div class="avg-view">
                            <ul>
                              <li>
                                <span class="th"></span> 224
                                <p>This Month</p>
                              </li>
                              <li>
                                <span class="la"></span> 96
                                <p>Last Month</p>
                              </li>
                              <li>
                                15
                                <p>Avg MTD</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="monthy-views">
                          <h5>Canceled</h5>
                          <div class="monthy">
                            <div id="serviceschat7">
                               <apexchart v-if="chart" type="donut" :options="donutchartOptions" :series="donutseries"></apexchart>
                            </div>
                          </div>
                          <div class="avg-view">
                            <ul>
                              <li>
                                <span class="th"></span> 224
                                <p>This Month</p>
                              </li>
                              <li>
                                <span class="la"></span> 96
                                <p>Last Month</p>
                              </li>
                              <li>
                                15
                                <p>Avg MTD</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="monthy-views">
                          <h5>Rental</h5>
                          <div class="monthy">
                            <div id="serviceschat8">
                               <apexchart v-if="chart" type="donut" :options="donutchartOptions" :series="donutseries"></apexchart>
                            </div>
                          </div>
                          <div class="avg-view">
                            <ul>
                              <li>
                                <span class="th"></span> 224
                                <p>This Month</p>
                              </li>
                              <li>
                                <span class="la"></span> 96
                                <p>Last Month</p>
                              </li>
                              <li>
                                15
                                <p>Avg MTD</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="monthy-views">
                          <h5>Valet</h5>
                          <div class="monthy">
                            <div id="serviceschat10">
                               <apexchart v-if="chart" type="donut" :options="donutchartOptions" :series="donutseries"></apexchart>
                            </div>
                          </div>
                          <div class="avg-view">
                            <ul>
                              <li>
                                <span class="th"></span> 224
                                <p>This Month</p>
                              </li>
                              <li>
                                <span class="la"></span> 96
                                <p>Last Month</p>
                              </li>
                              <li>
                                15
                                <p>Avg MTD</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="monthy-views">
                          <h5>Shuttle</h5>
                          <div class="monthy">
                            <div id="serviceschat11">
                               <apexchart v-if="chart" type="donut" :options="donutchartOptions" :series="donutseries"></apexchart>
                            </div>
                          </div>
                          <div class="avg-view">
                            <ul>
                              <li>
                                <span class="th"></span> 224
                                <p>This Month</p>
                              </li>
                              <li>
                                <span class="la"></span> 96
                                <p>Last Month</p>
                              </li>
                              <li>
                                15
                                <p>Avg MTD</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="monthy-views">
                          <h5>Web & Mobile</h5>
                          <div class="monthy">
                            <div id="serviceschat12">
                               <apexchart v-if="chart" type="donut" :options="donutchartOptions" :series="donutseries"></apexchart>
                            </div>
                          </div>
                          <div class="avg-view">
                            <ul>
                              <li>
                                <span class="th"></span> 224
                                <p>This Month</p>
                              </li>
                              <li>
                                <span class="la"></span> 96
                                <p>Last Month</p>
                              </li>
                              <li>
                                15
                                <p>Avg MTD</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="monthy-views">
                          <h5>BDC</h5>
                          <div class="monthy">
                            <div id="serviceschat13">
                               <apexchart v-if="chart" type="donut" :options="donutchartOptions" :series="donutseries"></apexchart>
                            </div>
                          </div>
                          <div class="avg-view">
                            <ul>
                              <li>
                                <span class="th"></span> 224
                                <p>This Month</p>
                              </li>
                              <li>
                                <span class="la"></span> 96
                                <p>Last Month</p>
                              </li>
                              <li>
                                15
                                <p>Avg MTD</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- monthy-view -->
                    </div>
                    <!-- monnt-end -->
                  </div>
                  <!-- Month tabs end -->
                </div>
              </div>
              <!-- time-tabs -->
            </div>
          </div>
          <!-- Book-tab=end -->
        </div>
      </div>
      <!-- call-box -->
    </div>
    <!-- dashboard-grap -->
  </div>
</template>
<script>
import carousel from "vue-owl-carousel";
export default {
  name: "services",
  components: { carousel },
  data() {
    return {
      chart: false,
      donutseries: [49, 35],
        donutchartOptions: {
            chart: {
              type: 'donut',
            },
             colors: ['#47CEFF', '#3151A1'],
             legend: {
                show: false
            },
         responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    }
                }
            }]
          },
      series: [
        {
          name: "Net Profit",
          data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
        },
        {
          name: "Revenue",
          data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
        },
        {
          name: "Free Cash Flow",
          data: [35, 41, 36, 26, 45, 48, 52, 53, 41],
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
        },
        colors: ["#47CEFF", "#3151A1", "#19BE93", "#FFCB46", "#FC825C"],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 8,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [
            "8:00 AM",
            "9:00 AM",
            "10:00 AM",
            "11:00 AM",
            "12:00 PM",
            "1:00 PM",
            "2:00 PM",
            "3:00 PM",
            "4:00 PM",
          ],
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "$ " + val + " thousands";
            },
          },
        },
        fill: {
          opacity: 1,
        },
      },
    };
  },

  created() {
    this.chart = true;
  },
};
</script>
<style scoped>
.st0 {
  fill: #a2a8b8;
}
.st1 {
  fill: none;
}
.title-time{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}
  
</style>